const messages = {
	es: {
		translations: {
			signup: {
				title: "Registro",
				toasts: {
					success:
						"¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
					fail: "Error creando el usuario. Verifica la data reportada.",
				},
				form: {
					name: "Nombre",
					email: "Correo Electrónico",
					password: "Contraseña",
				},
				buttons: {
					submit: "Regístrate",
					login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
				},
			},
			login: {
				title: "Inicio de Sesión",
				form: {
					email: "Correo Electrónico",
					password: "Contraseña",
				},
				buttons: {
					submit: "Ingresa",
					register: "Regístrarme",
					restart: "¿Olvidaste tu contraseña?"
				},
			},
			companies: {
				title: "Registrar Empresa",
				form: {
					name: "Nombre de la Empresa",
					plan: "Plan",
					token: "Token",
					submit: "Registrar",
					success: "La empresa se ha creado con exito!",
				},
			},
			auth: {
				toasts: {
					success: "¡Inicio de sesión exitoso!",
				},
				token: "Token",
			},
			dashboard: {
				charts: {
					perDay: {
						title: "Tickets de hoy: ",
					},
				},
			},
			departmentsHub: {
				title: "Gestión de Departamentos",
				tabs: {
					departments: "Departamentos",
					users: "Usuarios",
					compare: "Comparar",
				},
			},
			dashboardGeneral: {
				greeting: {
					morning: "¡Buenos días!",
					afternoon: "¡Buenas tardes!",
					evening: "¡Buenas noches!",
				},
				weekdays: {
					sunday: "Domingo",
					monday: "Lunes",
					tuesday: "Martes",
					wednesday: "Miércoles",
					thursday: "Jueves",
					friday: "Viernes",
					saturday: "Sábado",
				},
				months: {
					january: "enero",
					february: "febrero",
					march: "marzo",
					april: "abril",
					may: "mayo",
					june: "junio",
					july: "julio",
					august: "agosto",
					september: "septiembre",
					october: "octubre",
					november: "noviembre",
					december: "diciembre",
				},
				dateJoiner: "de",
				filterButton: "Filtrar",
				periods: {
					hoy: "Hoy",
					ayer: "Ayer",
					hoyAyer: "Hoy y ayer",
					semana: "Esta semana",
					semanaPasada: "Semana pasada",
					mes: "Este mes",
					mesPasado: "Mes pasado",
					tresMeses: "Últimos 3 meses",
					dia: "Día específico",
				},
				allAgents: "Todos los agentes",
				allGroups: "Todos los grupos",
				showing: "Datos de:",
				rightNow: "ahora mismo",
				scopesTitle: "Con qué se cierra, día a día",
				scopesEmpty: "Ningún cierre con ámbito en los últimos 14 días",
				trendScope: "últimos 14 días",
				adsScope: "últimos 5 anuncios · toda la empresa",
				adsDailyTotal: "chats por anuncios en 30 días",
				adsDailyEmpty: "Ningún anuncio trajo chats en 30 días",
				adUnnamed: "Anuncio",
				adPerChat: "por chat",
				adSpend: "invertido",
				adNotSynced: "campaña sin sincronizar",
				adFrom: "desde",
				adActive: "activo",
				adLast: "último",
				vsPrev: "frente al mismo día de la semana pasada",
				vsPeriod: "frente al período anterior",
				flow: {
					title: "Flujo de atención",
					source: "seguimiento en vivo",
					wait: "Espera",
					firstReply: "Primera respuesta",
					firstReplyHint: "Hasta que un asesor escribe",
					target: "objetivo",
					noTarget: "sin datos",
					defaultTarget: "objetivo por defecto",
					nineOfTen: "9 de cada 10, bajo",
					waitHint: "Desde que entra al departamento hasta que lo toman",
					handle: "Atención",
					handleHint: "Desde que lo toman hasta que lo cierran",
					reopens: "Reaperturas",
					reopensHint: "Chats cerrados que volvieron a abrirse",
					reopensRate: "{{reopens}} de {{closed}} chats cerrados",
					reopensNoBase: "Sin cierres en el período",
					reopensMax: "máx {{target}}%",
					reopensTarget: "{{label}}: menos del {{target}}% de los cierres.\nEntre {{target}}% y {{bad}}% conviene revisar; más de {{bad}}% se está cerrando antes de resolver.",
					transfers: "Transferencias",
					transfersHint: "Chats que cambiaron de asesor",
					returns: "Devoluciones",
					returnsHint: "Chats devueltos al departamento",
				},
				kpis: {
					totalActive: "Total activo",
					incoming: "Ingresados",
					recurrence: "Reincidencia",
					newClients: "Clientes nuevos",
					returningClients: "Ya escribieron antes",
					returningLabel: "ya habían escrito",
					hints: {
						incoming: "Entraron en el periodo",
						closed: "Resueltos en el periodo",
						recurrence: "Ya habían escrito antes",
						medianTime: "Duración típica",
						backlogNow: "Esperando ahora mismo",
						newClients: "Escriben por primera vez",
						returningClients: "Clientes que vuelven",
					},
					contactsSuffix: " contactos",
					medianTime: "Mediana atención",
					backlogNow: "Pendientes ahora",
					workingSuffix: " trabajando",
					pending: "Pendientes",
					open: "Trabajando",
					closedToday: "Cerrados",
					bot: "Por bot",
					agentsOnline: "Agentes online",
					agentsWorking: "Agentes trabajando",
					resolutionSuffix: "% resolución",
					botSuffix: "% del total",
					loadSuffix: " activos / agente",
					activeSuffix: " de {n} activos",
					callsReceived: "Llamadas recibidas",
					uniqueContacts: "Contactos únicos",
					totalChats: "Chats ingresados",
					repeatSuffix: " reincidentes",
					callsRated: "Calificadas",
					callsAvg: "Rating promedio",
				},
				help: {
					trend: "Chats que entraron y chats que se cerraron, un punto por día.\nVentana fija de 14 días: no cambia con el filtro de fechas. Son dos semanas completas, así que cada día tiene al lado su equivalente de la semana anterior.\nSí responde al filtro de grupo y de asesor.\nLos días sin actividad se muestran en cero, no se saltan.",
					scopes: "Con qué ámbito se cerró cada día, en los últimos 14 días.\nVentana fija: no cambia con el filtro de fechas. Sí responde al de grupo y asesor.\nEl grosor de cada banda es cuánto pesó ese ámbito ESE día. Sirve para ver que un día fue casi todo informativo y otro no.\nMisma definición estricta que \"Quién cierra qué\": solo cuenta si quien cerró es quien atendía.",
					statusOverview: "Reparto de los chats vivos AHORA MISMO.\nNo cambia con el filtro de fechas: es una foto del momento.",
					byAgent: "Por cada asesor: cuántos chats tiene ahora y cuántos cerró en el período.\nLa mediana es el tiempo típico de atención.",
					colWorking: "Chats asignados a este asesor que siguen abiertos AHORA MISMO.\nNo mira las fechas de arriba: aunque filtres una semana concreta, este número es siempre el de este instante. Por eso incluye chats de hace meses que nadie cerró.\nTécnico: tickets con status = 'open' y userId = este asesor.",
					colAttended: "Chats de los que se hizo cargo DENTRO del período elegido, sin importar si ya los cerró o no.\nCuenta el momento en que los tomó, no el resultado. Si en las fechas elegidas no tomó ningún chat nuevo, acá sale 0 aunque tenga decenas abiertos de antes.\nOJO: NO es \"Trabajando + Cerrados\". Son tres preguntas distintas y no suman entre sí.",
					colClosed: "Cierres hechos DENTRO del período elegido, venga el chat de donde venga.\nUn chat tomado el lunes y cerrado el martes cuenta en \"Atendidos\" del lunes y en \"Cerrados\" del martes: por eso estas dos columnas casi nunca cuadran entre sí.\nTécnico: tickets cerrados por este asesor con fecha de cierre dentro del rango.",
					colMedianTime: "Cuánto tarda en cerrar un chat, en general.\nNo es un promedio común: si un solo chat quedó abierto toda la noche por error, ese caso raro no cuenta para ensuciar el número. Se toma el tiempo del chat \"del medio\" (ni el más rápido ni el más lento).",
					whoClosesWhat: "Cierres agrupados por ámbito.\nSolo cuentan si quien cerró es el mismo que atendía: un cierre hecho por un admin no se le acredita a nadie.\nHaz clic en cualquier número para ver los chats.",
					byAd: "Los 5 anuncios con actividad más reciente, con TODO su histórico.\nNo cambia con el filtro de fechas NI con el de grupo: la inversión en publicidad es de la empresa entera, no de un departamento.\nAquí SÍ cuenta el cierre hecho por un admin, porque se mide el resultado del anuncio, no a quién acreditar. Por eso puede no cuadrar con \"Quién cierra qué\".",
					opportunities: "Dos cosas distintas que no se suman:\nIzquierda: contactos que cambiaron de estado en el período.\nDerecha: cómo está la cartera hoy (contactos con actividad en los últimos 90 días), sin importar la fecha elegida.",
					flow: "Espera: desde que el chat entra al departamento hasta que alguien lo toma.\nAtención: desde que lo toman hasta que lo cierran.\nSe muestra la mediana, no el promedio: un chat olvidado toda la noche no distorsiona el resto.",
					byQueue: "Lo que está sin resolver en este momento, repartido por departamento.\nNo cambia aunque cambies las fechas de arriba: esto es siempre el ahora.\n\"Sin departamento\" son chats que no le aparecen a nadie en su bandeja.",
					byLine: "Chats que tuvieron algún movimiento en las fechas que elegiste, según la línea por la que entraron.\nCuenta si el cliente escribió, si alguien respondió o si el chat cambió de estado, aunque sea un chat de hace meses.\nUno que nadie tocó en esas fechas no sale aquí.",
					calls: "Llamadas recibidas y su encuesta.\n\"Sin calificar\" significa que se envió la encuesta y el cliente aún no responde. NO significa que la llamada no se haya contestado.\nLa nota va de 1 a 3.",
					ratings: "Nota que dejaron los clientes a cada asesor, de 1 a 5.\n\"Reparto\" muestra si las notas están repartidas o concentradas: un promedio de 2 puede ser todas regulares, o mitad excelentes y mitad pésimas.",
					reopens: "Chats que se cerraron y el cliente volvió a escribir.\n\nMirá el porcentaje de arriba, no el número suelto: 30 sobre 100 cierres es grave, sobre 3000 es normal.\n\n🟢 Menos de 10%: bien.\n🟡 10% a 20%: revisá por qué vuelven.\n🔴 Más de 20%: se está cerrando antes de resolver.\n\nMás que el color, mirá si sube contra el período anterior.\n\nAbajo: con qué motivo se cerraron y en cuántas horas volvieron. Menos de 4 horas (en rojo) es cierre prematuro, no conversación nueva.",
				},
				sections: {
					statusOverview: "Chats activos",
					byAgent: "Chats por asesor",
					byQueue: "Chats por departamento",
					byLine: "Chats por conexión",
					activityByAgent: "Actividades por asesor",
					ungrouped: "Sin grupo",
					noQueue: "Sin departamento",
					byCloseReason: "Cierres por motivo",
					whoClosesWhat: "Quién cierra qué",
					byAd: "Anuncios de Meta",
					dailyChats: "Chats del día",
					calls: "Llamadas",
					noReason: "Sin motivo",
					otherScopes: "Otros",
				},
				opportunitiesBlock: {
					opportunities: "Oportunidades",
					flowTitle: "Cambiaron de estado",
					stockTitle: "Cómo están hoy",
					stockNote: "Contactos con actividad en los últimos 90 días",
					flowEmpty: "Nadie cambió de estado",
					stockEmpty: "Ningún contacto tiene estado",
					dailyTotal: "cambios en 30 días",
					dailyEmpty: "Sin cambios de estado en los últimos 30 días",
				},
				reopensBlock: {
					title: "Chats que volvieron",
					reason: "Se cerró como",
					who: "Lo cerró",
					count: "Veces",
					back: "Volvió a las",
					empty: "Ningún chat se reabrió en este período",
					hours: "h",
					dailyTotal: "reaperturas en 30 días",
					rateOf: "de los chats que cerraste volvieron a abrirse ({{reopens}} de {{closed}})",
					vsPrev: "{{points}} puntos vs. el período anterior (era {{prev}}%)",
					verdict: {
						ok: "Bien",
						warn: "Ojo",
						bad: "Mal",
					},
					dailyEmpty: "Sin reaperturas en los últimos 30 días",
				},
				trendBlock: {
					title: "Día a día",
					empty: "Sin datos en el período",
				},
				ratingsBlock: {
					title: "Cómo califican a cada asesor",
					average: "Promedio",
					spread: "Reparto",
					count: "Notas",
					empty: "Todavía nadie ha calificado en este período",
					seeDetail: "Ver el detalle",
					detailTitle: "Detalle de calificaciones",
					detailAll: "Todos los asesores",
					colDate: "Fecha",
					colAgent: "Asesor",
					colContact: "Contacto",
					colQueue: "Departamento",
					colRate: "Nota",
					colSource: "Origen",
					colNote: "Observación",
					colTicket: "Chat",
					srcSurvey: "Cliente",
					srcAudit: "Auditoría",
					byAuditor: "por",
					noTicket: "Sin chat",
					noNote: "—",
					limitNote: "Se muestran las 300 más recientes",
				},
				callsBlock: {
					received: "Recibidas",
					rated: "Calificadas",
					pending: "Sin calificar",
					noCalls: "No entraron llamadas",
					pendingHint: "Se les envió la encuesta y aún no responden",
					failed: "No se pudo avisar",
					avgOf: "de",
					noRatings: "Nadie ha calificado todavía",
					seeDetail: "Ver el detalle",
					byLine: "Por línea",
					detailTitle: "Detalle de llamadas",
					colDate: "Entró",
					colContact: "Contacto",
					colPhone: "Teléfono",
					colConnection: "Conexión",
					colStatus: "Estado",
					colRating: "Calificación",
					colTicket: "Chat",
					noTicket: "Sin chat",
					limitNote: "Se muestran las 300 más recientes",
				},
				statusNames: {
					open: "Trabajando",
					pending: "Pendiente",
					closed: "Cerrado",
					bot: "Bot",
				},
				statusLabels: {
					pending: "PENDIENTE",
					open: "TRABAJANDO",
					closed: "CERRADO",
					bot: "CON BOT",
					favorite: "EN FAVORITO",
				},
				table: {
					colChat: "Chat",
					colComment: "Comentario",
					openChat: "Clic para abrir el chat",
					noChat: "Sin chat",
					noConnection: "Sin conexión",
					closuresOf: "Cierres de",
					working: "Trabajando",
					clickToFilter: "Clic para filtrar por este asesor",
					clickForDetail: "Clic para ver el detalle",
					clickToExpand: "Clic para ver los asesores",
					colContact: "Contacto",
					otherCategories: "Otros",
					colReason: "Motivo",
					closeReasonsBreakdown: "Motivos de cierre",
					colLine: "Línea",
					colDate: "Fecha",
					pickCategory: "Elige un ámbito",
					pickCategoryHint: "Haz clic en un ámbito de la izquierda para ver sus chats.",
					clickForList: "Clic para ver los chats",
					filterByAgent: "Filtrar por este asesor",
					categories: "Ámbitos",
					categoriesTotal: "Total: {{total}}",
					medianTime: "Mediana",
					sessions: "sesiones",
					agent: "Asesor",
					online: "Online",
					active: "Activo",
					closed: "Cerrados",
					reason: "Razón",
					total: "Total",
					users: "Usuarios",
					name: "Nombre",
					state: "Estado",
					ticket: "Ticket",
					user: "Usuario",
					connection: "Conexión",
					comment: "Comentario",
					lastUser: "Último usuario",
				},
				noResults: "No hay resultados",
				loading: "Cargando...",
				noComment: "Sin comentario",
				noUser: "Sin usuario",
				details: "Detalles:",
				recordsOf: "Registros de",
				close: "Cerrar",
				ticketSingular: "ticket",
				ticketPlural: "tickets",
				unknownReason: "Desconocido",
			},
			connections: {
				title: "Conexiones",
				toasts: {
					deleted:
						"¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
				},
				confirmationModal: {
					deleteTitle: "Borrar",
					deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
					disconnectTitle: "Desconectar",
					disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
				},
				buttons: {
					add: "Agrega WhatsApp",
					disconnect: "Desconectar",
					reconnect: "Reconectar",
					tryAgain: "Inténtalo de nuevo",
					qrcode: "QR CODE",
					newQr: "Nuevo QR CODE",
					connecting: "Conectando",
					newConnection: "Nueva Conexión",
				},
				status: {
					connected: "Conectado",
					disconnected: "Desconectado",
					pending: "Pendiente",
					qrcode: "Escanear QR",
					opening: "Conectando…",
					timeout: "Tiempo expirado",
					pairing: "Emparejando",
				},
				state: {
					new: "Nueva",
					warmingUp: "Calentando",
					asset: "Activa",
					rest: "Descanso",
					punished: "Penalizada",
				},
				chips: {
					lineSingular: "línea",
					linePlural: "líneas",
					connectedSingular: "conectada",
					connectedPlural: "conectadas",
					default: "Default",
					backup: "Respaldo",
					botActive: "Tiene un Prompt (bot de IA) activo",
					n8nActive: "Tiene una integración n8n activa",
				},
				rowActions: {
					edit: "Editar",
					delete: "Eliminar",
				},
				emptyChannel: "Sin conexiones configuradas para este canal.",
				search: {
					placeholder: "Buscar...",
					noResults: "Ninguna conexión coincide con la búsqueda.",
				},
				toolTips: {
					disconnected: {
						title: "No se pudo iniciar la sesión de WhatsApp",
						content:
							"Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
					},
					qrcode: {
						title: "Esperando la lectura del código QR",
						content:
							"Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
					},
					connected: {
						title: "Conexión establecida",
					},
					timeout: {
						title: "Se perdió la conexión con el teléfono celular",
						content:
							"Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
					},
				},
				table: {
					name: "Nombre",
					operational_status: "Estado funcional",
					connection_status: "Estado de conexión",
					lastUpdate: "Última Actualización",
					default: "Por Defecto",
					actions: "Acciones",
					session: "Sesión",
					nameNumber: "Nombre / Número",
					state: "Estado",
					operational: "Operativa",
					credits: "Créditos",
					department: "Departamento",
					automation: "Automatización",
					flags: "Flags",
				},
			},
			whatsappModal: {
				title: {
					add: "Agrega WhatsApp",
					edit: "Edita WhatsApp",
				},
				tabs: {
					general: "General",
					api: "API",
					bot: "Bot",
					campaigns: "Campañas",
				},
				sections: {
					identification: "Identificación de la línea",
					autoMessages: "Mensajes automáticos",
					routing: "Enrutamiento",
					token: "Token de acceso",
					operationalState: "Configuración operativa",
					bulk: "Masivos",
					backupLine: "Línea de respaldo",
				},
				operationalState: {
					placeholder: "Estado de la línea",
					none: "Sin estado",
					new: "Nueva conexión",
					warmingUp: "Calentando / Warming Up",
					rest: "En descanso",
					punished: "Penalizada / Punished",
				},
				deliverySpeed: {
					placeholder: "Velocidad de envío (ms)",
					none: "Sin velocidad",
					sec2: "2 segundos",
					sec5: "5 segundos",
					sec10: "10 segundos",
					sec15: "15 segundos",
					sec20: "20 segundos",
					sec30: "30 segundos",
					sec45: "45 segundos",
					min1: "1 minuto",
					min2: "2 minutos",
					min3: "3 minutos",
					min5: "5 minutos",
					min10: "10 minutos",
				},
				form: {
					name: "Nombre",
					default: "Por Defecto",
					defaultDesc: "Esta será la línea que se use cuando no elijas otra en específico.",
					number: "Numero",
					active: "Activo",
					inactive: "Inactivo",
					sendIdQueue: "Departamento",
					timeSendQueue: "Redirigir al Departamento en X minutos",
					queueRedirection: "Comportamiento del bot",
					queueRedirectionDesc: "Configura cuántas veces y cada cuánto el bot reintenta contactar, y cuándo cerrar chats por inactividad.",
					routingDesc: "Elige cómo quieres recibir a tus clientes: con un menú de opciones (Departamentos) o con un asistente inteligente (Open.AI). Solo puedes usar uno de los dos a la vez.",
					prompt: "Open.AI",
					tokenDesc: "Genera este código para conectar esta línea con otros sistemas (tu web, un CRM, etc.) y enviar mensajes automáticamente, como si fuera una API.",
					operationalStateDesc: "Controla qué tan rápido se envían los mensajes para evitar que WhatsApp bloquee el número, sobre todo si es nuevo o lo recuperaste hace poco.",
					maxUseBotQueues: "Enviar bot X veces",
					timeUseBotQueues: "Intervalo en minutos entre envíos de bot",
					expiresTicket: "Cerrar chats abiertos después de X minutos",
					expiresInactiveMessage: "Mensaje de cierre por inactividad",
					bulkEnabled: "Habilitado para masivos / campañas",
					bulkEnabledDesc: "Permite usar esta línea para envío de mensajes masivos",
					backupLineEnabled: "Usar como línea de respaldo",
					backupLineDesc: "Cuando otra línea no pueda enviar un mensaje, este dispositivo será utilizado como alternativa de envío",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "WhatsApp guardado satisfactoriamente.",
			},
			qrCode: {
				message: "Lée el código QR para empezar la sesión.",
			},
			contacts: {
				title: "Contactos",
				toasts: {
					deleted: "¡Contacto borrado satisfactoriamente!",
				},
				searchPlaceholder: "Buscar...",
				confirmationModal: {
					deleteTitle: "Borrar",
					importTitlte: "Importar contactos",
					deleteMessage:
						"¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
					importMessage:
						"¿Quieres importar todos los contactos desde tu teléfono?",
				},
				buttons: {
					import: "Importar Contactos",
					cate: "Agregar Categoria",
					add: "Agregar Contacto",
				},

				table: {
					name: "Nombre",
					whatsapp: "WhatsApp",
					email: "Correo Electrónico",
					category: "Categoria",
					representative: "Representante",
					actions: "Acciones",
				},
			},
			contactsCategori: {
				title: "Categoria de Contactos",

				buttons: {
					cate: "Agregar Categoria",
				},

				form: {
					name: "Nombre de la categoria",
				},
			},
			queueIntegrationModal: {
				title: {
					add: "Agregar proyecto",
					edit: "Editar proyecto",
				},
				form: {
					id: "ID",
					type: "Tipo",
					name: "Nombre",
					projectName: "Nombre del Proyecto",
					language: "Idioma",
					jsonContent: "Contenido JSON",
					urlN8N: "URL",
					typebotSlug: "Typebot - Slug",
					typebotExpires: "Tiempo en minutos para expirar una conversación",
					typebotKeywordFinish: "Palabra para finalizar la conversación",
					typebotUnknownMessage: "Mensaje de opción inválida",
					typebotKeywordRestart: "Palabra para reiniciar el flujo",
					typebotRestartMessage: "Palabra para reiniciar el mensaje",
					typebotDelayMessage: "Intervalo (ms) entre mensaje",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
					test: "Probar Bot",
				},
				messages: {
					testSuccess: "Integración probada exitosamente",
					addSuccess: "Integración agregada exitosamente",
					editSuccess: "Integración editada exitosamente",
				},
			},
			promptModal: {
				settings: {
					model: "Modelo",
					modelHelp: "Modelo de OpenAI que escribe las respuestas en el chat.",
					apiKey: "Clave de API",
					apiKeyHelp: "Clave de OpenAI con la que trabaja este agente; el consumo se cobra a esa cuenta.",
					accent: "Acento",
					accentHelp: "Acento con el que habla la IA cuando responde con voz.",
					temperature: "Temperatura",
					temperatureHelp: "Más baja = respuestas más precisas y constantes. Recomendado: 0.3.",
					maxTokens: "Largo máximo de la respuesta",
					maxTokensHelp: "Tokens que puede usar en cada respuesta. Si se queda corto, la respuesta se corta.",
					maxMessages: "Mensajes de historial",
					maxMessagesHelp: "Cuántos mensajes anteriores del chat lee para entender el contexto.",
					handoff: "Departamento de traspaso",
					handoffHelp: "A dónde pasa el chat cuando la IA lo transfiere a un asesor.",
				},
				form: {
					name: "Nombre",
					prompt: "Prompt",
					promptEditorLabel: "Editar",
					promptPreviewLabel: "Vista previa",
					promptPreviewEmpty: "El prompt está vacío.",
					voice: "Voz",
					max_tokens: "Máximo de Tokens en la respuesta",
					temperature: "Temperatura",
					apikey: "Clave de API",
					max_messages: "Máximo de mensajes en el historial",
					voiceKey: "Clave de voz de API",
					voiceRegion: "Región de voz",
					model: "Modelo de texto",
					namePlaceholder: "Nombre del agente",
					tabPrompt: "Prompt",
					tabSettings: "Configuración",
					tabBasic: "Básico",
					type: "Tipo",
					tabWhatsapp: "WhatsApp (voz)",
					tabEspecialistas: "Especialistas",
					tabHerramientas: "Herramientas",
					sectionWhatsappHelp: "Si elegís una voz, el bot responde también con un audio en WhatsApp además del texto.",
					sectionGeneral: "Configuración",
					sectionVoiceAccent: "Acento de la IA",
					voiceAccent: "Acento",
					voiceAccentHelp: "Cómo habla la IA por voz (llamadas y avatar). Neutro = sin instrucción de acento.",
					sectionModel: "Modelo",
					sectionLimits: "Límites",
					sectionHandoff: "Derivación",
					handoffQueue: "Derivar a",
					voiceNone: "Sin voz (solo texto)",
					avatarWebNota: "El modelo y la voz del avatar de voz en el sitio web se configuran en Conexiones → tu conexión de Avatar, no acá.",
					validacion: {
						requerido: "Obligatorio",
						nombreCorto: "Muy corto",
						nombreLargo: "Muy largo",
						promptCorto: "Describí las instrucciones para la IA (mínimo 50 caracteres)",
						colaRequerida: "Elegí un departamento",
					},
					especialistas: {
						ayuda: "Un especialista responde solo cuando este prompt lo consulta, en chat o en llamada. No atiende clientes por su cuenta.",
						guardarPrimero: "Guarde el prompt primero para poder configurar especialistas.",
						esEspecialistaDe: "Este prompt es especialista de",
						sinPadres: "Este especialista todavía no está vinculado a ningún prompt. Vincúlelo desde el prompt de texto o de llamada que lo va a usar.",
						quitarVinculo: "Quitar vínculo",
						vinculados: "Especialistas vinculados",
						sinEspecialistas: "Todavía no hay ninguno.",
						cuandoUsarlo: "Cuándo usarlo",
						cuandoUsarloPlaceholder: "Ej: usar cuando el cliente quiera rastrear un envío",
						vincularExistente: "Vincular un prompt existente",
						elegirPrompt: "Elegí un prompt",
						vincular: "Vincular",
						vinculado: "Especialista vinculado",
						desvinculado: "Especialista desvinculado",
						sinDisponibles: "No hay otros prompts disponibles para vincular como especialistas.",
					},
					herramientas: {
						guardarPrimero: "Guardá el prompt primero para poder configurar herramientas.",
						configuradas: "Herramientas configuradas",
						sinHerramientas: "Todavía no hay ninguna.",
						nombre: "Nombre",
						nombrePlaceholder: "Ej: Rastreo de envío",
						descripcion: "Cuándo usarla",
						descripcionPlaceholder: "Usar cuando el cliente quiera rastrear un envío",
						url: "URL del webhook",
						urlPlaceholder: "https://tu-n8n.com/webhook/rastreo",
						connection: "Conexión de datos",
						sinConexion: "Sin conexión · URL propia",
						filters: "Filtros fijos (opcional)",
						filtersHelp: "Se agregan a toda consulta. Ej: select=text,metadata&limit=5 — sirve para no traer columnas pesadas ni filas de más.",
						nuevaTitulo: "Nueva herramienta",
						editarTitulo: "Editar herramienta",
						guardar: "Guardar",
						source: "Origen de los datos",
						kind: "Tipo de herramienta",
						kindDatabase: "Base de datos · Supabase, PostgREST u otra conexión",
						kindWebhook: "HTTP / REST · una URL propia (n8n, API externa)",
						noConnections: "No hay conexiones cargadas. Se crean en Automatización → Conexiones de datos.",
						query: "Consulta SQL",
						filter: "Filtro (JSON)",
						filterHelp: "Vacío trae los primeros documentos. Usá :nombre donde va un dato del cliente, igual que en los parámetros de abajo.",
						queryHelp: "Solo lectura. Los datos del cliente van como :nombre y se ligan como parámetros, nunca se pegan al texto.",
						cambiarOrigen: "Cambiar origen",
						columnsNoList: "No se pudieron leer las columnas de la conexión. Escribilas separadas por comas.",
						columns: "Columnas a traer",
						columnsHelp: "Vacío trae todas. Dejá afuera las pesadas, como los vectores de embedding.",
						limit: "Máximo de filas",
						searchMode: "Tipo de búsqueda",
						searchText: "Por texto · encuentra lo que se escribe igual",
						searchVector: "Semántica · compara significados",
						rpc: "Función de búsqueda",
						rpcHelp: "La función que hace la comparación de vectores, con el prefijo rpc/.",
						vectorParam: "Parámetro que se convierte en vector",
						vectorParamHelp: "Tiene que llamarse igual que el argumento de la función.",
						embeddingModel: "Modelo de embeddings",
						embeddingWarning: "El modelo tiene que ser el MISMO con el que se cargaron los vectores de la tabla. Si no coincide no da error: devuelve resultados al azar.",
						collection: "Colección",
						collectionHelp: "Tablas disponibles:",
						collectionNoList: "No se pudo leer el listado de la conexión. Escribí el nombre de la tabla.",
						url: "URL del webhook",
						headersConConexion: "Se suman a las de la conexión. Normalmente va vacío.",
						transporte: "Conexión",
						metodo: "Método",
						headers: "Autenticación (opcional)",
						headersAyuda: "Solo si la API pide una clave. Usa una de solo lectura.",
						parametros: "Datos que envía",
						parametroNombrePlaceholder: "nombre_del_dato",
						parametroDescripcionPlaceholder: "Qué es. Ej: número de guía, cédula o teléfono",
						parametroFormatoLabel: "Formato",
						parametroValorFijoPlaceholder: "Valor que se envía siempre",
						parametroValorFijoAyuda: "Si lo llenás, este dato ya no se le pide al modelo: el sistema lo manda siempre igual, tal cual lo escribiste acá.",
						parametroAutoFillLabel: "O completar con",
						parametroAutoFillAyuda: "El sistema lo llena solo, sin pedírselo al modelo.",
						parametroAutoFillNinguno: "Nada (lo completa el modelo)",
						parametroAutoFillTelefono: "Teléfono del contacto",
						parametroAutoFillNombre: "Nombre del contacto",
						sectionWhatItDoes: "Qué hace",
						sectionWhatItDoesHelp: "El agente la usa cuando se cumple lo que escribas en «Cuándo usarla».",
						sectionWhere: "Dónde consulta",
						sectionDataHelp: "Cada dato que la herramienta manda en la consulta, y de dónde sale.",
						colField: "Dato",
						colSource: "Lo llena",
						sourceAgent: "El agente (lo pide al cliente)",
						sourceFixed: "Un valor fijo",
						sourceAutomatic: "Lo pone el sistema automáticamente",
						noData: "Esta herramienta no envía datos.",
						headerName: "Nombre",
						headerValue: "Valor",
						addHeader: "Agregar cabecera",
						agregarParametro: "Agregar dato",
						agregar: "Agregar herramienta",
						agregarNueva: "Agregar nueva herramienta",
						editar: "Editar",
						guardar: "Guardar",
						cancelar: "Cancelar",
						agregada: "Herramienta agregada",
						actualizada: "Herramienta actualizada",
						eliminada: "Herramienta eliminada",
					},
				},
				success: "Prompt guardado con éxito",
				title: {
					add: "Agregar Prompt",
					edit: "Editar Prompt",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
					discard: "Descartar cambios",
				},
			},
			prompts: {
				active: "Encendido",
				inactive: "Apagado",
				activeHelp: "Si está apagado, el agente principal transfiere a un asesor en vez de consultar a este especialista.",
				title: "Prompt",
				empty: "Todavía no hay ningún prompt.",
				tabs: {
					text: "Texto",
					voice: "Llamada",
				},
				emptyTab: {
					text: "Todavía no hay prompts de texto.",
					voice: "Todavía no hay prompts de llamada.",
				},
				unlinkedSpecialists: "Especialistas sin vincular",
				delete: "Eliminar",
				selectHint: "Elija un agente de la lista para ver y editar su prompt.",
				wrongTypeHint: "no corresponde a este canal",
				filterType: "Tipo",
				types: {
					all: "Todos",
					text: "Texto",
					voice: "Llamada",
					specialist: "Especialista",
				},
				typeHelp: {
					text: "Atiende chats: WhatsApp, web, Instagram, Facebook.",
					voice: "Atiende llamadas telefónicas y el avatar de voz.",
					specialist: "Lo consultan los prompts de texto y de llamada. No atiende clientes por su cuenta.",
				},
				card: {
					sinCola: "Sin departamento asignado",
					sinInstrucciones: "Sin instrucciones todavía",
					especialistaDe: "Especialista de",
					sinPadres: "Sin vincular a ningún prompt",
					especialista: "especialista",
					especialistas: "especialistas",
					herramienta: "herramienta",
					herramientas: "herramientas",
					avatarVoz: "Avatar de voz",
					vozWhatsapp: "Voz en WhatsApp",
				},
				table: {
					agente: "Agente",
					departamento: "Departamento",
					modeloVoz: "Modelo y voz",
					tipo: "Tipo",
					resumen: "Resumen",
					detalles: "Detalles",
					acciones: "Acciones",
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage: "¿Estás seguro? ¡Esta acción no se puede deshacer!",
				},
				buttons: {
					add: "Agregar Prompt",
				},
			},
			contactModal: {
				title: {
					add: "Agregar contacto",
					edit: "Editar contacto",
				},
				form: {
					mainInfo: "Datos del contacto",
					extraInfo: "Información adicional",
					connectedInfo: "Conexión disponible",
					name: "Nombre",
					number: "Número de WhatsApp",
					email: "Email",
					username: "Usuario de WhatsApp",
					usernameHelp: "Lo define el cliente en WhatsApp; se actualiza solo.",
					usernameManualHelp: "Solo para identificarlo -- si no le escribió antes, no podés iniciarle una conversación con esto.",
					numberOrUsernameRequired: "Ingresá un número o un usuario de WhatsApp",
					extraName: "Nombre del campo",
					extraValue: "Valor",
				},
				representate: {
					title: "Representante",
					fieldLabel: "Escriba un representante",
					noOptions: "No se encontraron usuarios con ese nombre",
				},
				buttons: {
					addExtraInfo: "Agregar Información",
					okAdd: "Agregar",
					sendToCRM: "Enviar a CRM",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "Contacto guardado con exito.",
			},
			queueModal: {
				title: {
					add: "Agregar departamento",
					edit: "Editar departamento",
					tabData: "Datos del Departamento",
					tabSchedules: "Horarios de Atención",
					tabAssignment: "Equipo y asignación",
				},
				sections: {
					basics: "Datos generales",
					bot: "Atención automática",
					messages: "Mensajes",
					survey: "Encuesta de satisfacción",
				},
				assignment: {
					autoAssignTitle: "Habilitar asignación automática",
					autoAssignHelp: "Cada chat nuevo que llega al departamento se asigna solo a un miembro del equipo, al que tenga menos chats abiertos. En departamentos con IA, se asigna recién cuando la IA transfiere.",
					offlineTitle: "Asignar a usuarios fuera de línea",
					offlineHelp: "Si está activado, también se asignan chats a los miembros que no están conectados.",
					redistributeTitle: "Redistribuir chats de usuarios no disponibles",
					redistributeHelp: "Si llega un mensaje a un chat cuyo asesor está fuera de línea, el chat pasa a otro miembro conectado del equipo.",
					agents: "Agentes",
					searchAgent: "Buscar agente",
					noAgents: "No hay agentes que coincidan con la búsqueda.",
					apply: "Aplicar",
					columns: {
						name: "Nombre",
						email: "Correo electrónico",
						member: "Miembro",
						memberHelp: "Pertenece a este departamento: ve sus chats y puede atenderlos. Si está apagado, no ve los chats del departamento.",
						autoAssign: "Asignación automática",
						autoAssignHelp: "Recibe chats nuevos de forma automática cuando la asignación automática del departamento está activada. Si está apagado, sigue siendo miembro y puede tomar chats a mano, pero no le llegan solos.",
					},
				},
				form: {
					name: "Nombre",
					color: "Color",
					greetingMessage: "Mensaje de bienvenida",
					complationMessage: "Mensaje de conclusión",
					outOfHoursMessage: "Mensaje fuera de horario",
					ratingMessage: "Mensaje de calificación",
					token: "Token API",
					orderQueue: "Orden de la fila (Bot)",
					integrationId: "Integracion",
					botMode: "Bot del departamento",
					botModeNone: "Ninguno",
					botModePrompt: "Prompt (IA)",
					botModeIntegration: "Integración externa (n8n, Typebot, Dialogflow)",
					queueGroup: "Grupo de departamentos",
					none: "Ninguno",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
					attach: "Adjuntar Archivo",
					saveSchedules: "Agregar",
				},
				toasts: {
					deleted: "Archivo eliminado con éxito",
					queueSaved: "Departamento guardado exitosamente",
					clickSaveToApply: "Haga clic en guardar para registrar los cambios",
				},
				flowPlaceholder: "Guarda el departamento primero para poder configurar el menú de opciones del bot.",
			},
			queueFlowBuilder: {
				noMessage: "Sin mensaje",
				rootTitle: "Menú principal",
				rootSubtitle: "El bot muestra estas opciones al cliente",
				defaultOptionTitle: "Nueva opción",
				editTitle: "Editar opción",
				toasts: {
					optionSaved: "Opción guardada",
					fileAttached: "Archivo adjuntado",
				},
				deleteModal: {
					title: "Eliminar opción",
					messageWithChildren: "Esta opción tiene sub-opciones que quedarán sueltas. ¿Eliminar de todas formas?",
					message: "¿Eliminar esta opción del menú?",
				},
				buttons: {
					addOption: "Agregar opción",
					organize: "Organizar",
					organizeTooltip: "Reorganizar el árbol automáticamente",
					save: "Guardar",
					addSubOption: "Agregar sub-opción",
					deleteOption: "Eliminar opción",
				},
				form: {
					numberTooltip: "Lo que el cliente debe marcar para elegir esta opción",
					number: "Número",
					title: "Título",
					message: "Mensaje que envía el bot",
				},
				media: {
					attachedFile: "archivo adjunto",
					attach: "Adjuntar archivo",
					dropHint: "o arrastra un archivo aquí",
				},
			},
			userModal: {
				title: {
					add: "Agregar usuario",
					edit: "Editar usuario",
				},
				form: {
					name: "Nombre",
					email: "Correo Electrónico",
					password: "Contraseña",
					profile: "Perfil",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "Usuario guardado satisfactoriamente.",
			},
			scheduleModal: {
				title: {
					add: "Nuevo Agendamiento",
					edit: "Editar Agendamiento",
				},
				form: {
					body: "Mensaje",
					contact: "Contacto",
					sendAt: "Datos del agendamiento",
					sentAt: "Datos de envio",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Editar",
					cancel: "Cancelar",
				},
				success: "Se ha agendado con exito.",
			},
			tagModal: {
				title: {
					add: "Nuevo Tag",
					edit: "Editar Tag",
				},
				form: {
					name: "Nombre",
					color: "Color",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Editar",
					cancel: "Cancelar",
				},
				success: "Tag guardado con exito",
			},
			chat: {
				noTicketMessage: "Selecciona un ticket para empezar a chatear.",
			},
			ticketsManager: {
				buttons: {
					newTicket: "Nuevo",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Departamentos",
			},
			tickets: {
				toasts: {
					deleted: "El ticket en el que estabas ha sido borrado.",
				},
				notification: {
					message: "Mensaje de",
				},
				tabs: {
					open: { title: "Bandeja" },
					closed: { title: "Cerrados" },
					search: { title: "Buscar" },
					archived: { title: "Archivados" },
				},
				search: {
					placeholder: "Buscar por nombre",
					ariaLabel: "Buscar tickets",
				},
				buttons: {
					showAll: "Todos",
				},
				myTickets: "Mis Chats",
				allTickets: "Todos los chats",
				filters: {
					show: "Abrir filtros",
					hide: "Ocultar filtros",
				},
				unread: {
					showAll: "Mostrar todos",
					showUnreadOnly: "Mostrar no leídos",
				},
				newConversation: "Nueva conversación",
			},
			transferTicketModal: {
				title: "Transferir Ticket",
				fieldLabel: "Escriba para buscar usuarios",
				fieldQueueLabel: "Transferir a un departamento",
				fieldQueuePlaceholder: "Selecciona un departamento",
				noOptions: "No se encontraron usuarios con ese nombre",
				buttons: {
					ok: "Transferir",
					cancel: "Cancelar",
				},
			},
			ticketsList: {
				favoriteHeader: "Favoritos",
				pendingHeader: "Pendientes",
				assignedHeader: "En Conversacion",
				botHeader: "ChatBot",
				noTicketsTitle: "¡Nada acá!",
				noTicketsMessage:
					"No se encontraron tickets con este estado o término de búsqueda",
				buttons: {
					accept: "Aceptar",
					closed: "Finalizar",
					reopen: "Reabrir"
				},
			},
			newTicketModal: {
				title: "Crear Ticket",
				fieldLabel: "Escribe para buscar un contacto",
				add: "Añadir",
				noSendableIdentity: "Este contacto no tiene número ni te escribió antes -- no se le puede abrir un ticket todavía.",
				buttons: {
					ok: "Guardar",
					cancel: "Cancelar",
				},
			},

			mainDrawer: {
				listItems: {
					dashboard: "Panel de Control",
					connections: "Conexiones",
					calls: "Llamadas",
					callHistory: "Historial",
					callMetrics: "Métricas",
					aiCosts: "Facturación",
					aiReplies: "Auditoría de IA",
					tickets: "Chats",
					contacts: "Contactos",
					queues: "Departamentos",
					api: "API",
					administration: "Administración",
					users: "Usuarios",
					settings: "Configuración",
					prompts: "Agentes IA",
					dataSources: "Conexiones de datos",
					knowledge: "Base de conocimiento",
					queueIntegration: "Integraciones",
					testing: "Pruebas",
					annoucements: "Informativos",
					campaigns: "Campañas",
					chats: "Chat Interno",
					financeiro: "Finanzas",
					helps: "Ayuda",
					messagesAPI: "API",
					quickMessages: "Respuestas Rápidas",
					schedules: "Agendamientos",
					tags: "Tags",
					templateMessage: "Plantillas de Mensajes",
					adCampaigns: "Anuncios",
					management: "Gestión",
					kanbanTags: "Gestión de Tags",
					kanbanContacts: "Gestión de Contactos",
					reports: "Reportes",
					auditor: "Auditoria",
					activity: "Registro de Actividades",
					analytics: "Analítica",
					automation: "Automatización",
					company: "Empresa",
					campaignsList: "Listado",
					campaignsSettings: "Configuración",
				},
				appBar: {
					user: {
						profile: "Perfil",
						logout: "Cerrar Sesión",
					},
					language: {
						title: "Cambiar idioma",
					},
				},
			},
			promptVersions: {
				title: "Historial de versiones",
				history: "Historial",
				open: "Ver el historial de versiones de este prompt",
				empty: "Todavía no hay versiones guardadas. Se crea una cada vez que guarda un cambio en el prompt.",
				current: "Actual",
				columns: {
					version: "Versión",
					date: "Fecha",
					note: "Motivo",
				},
				compare: "Cambios desde la v{{version}} hasta la actual",
				changes: "{{count}} línea(s) distinta(s)",
				noChanges: "Igual a la actual",
				pick: "Elija una versión para ver qué cambió.",
				legend: "Verde: se agregó después · Rojo tachado: estaba en esa versión y se quitó",
				close: "Cerrar",
				restore: "Restaurar v{{version}}",
				confirmRestore: "¿Restaurar la versión {{version}}? El prompt actual se guarda en el historial, así que podrá volver a él.",
				restored: "Se restauró la versión {{version}}.",
				notePlaceholder: "Motivo del cambio (opcional), ej.: corregí la dirección de Elizabeth",
			},
			promptCoach: {
				title: "Corregir al agente",
				reply: "Respuesta del agente",
				correctionLabel: "¿Qué estuvo mal o qué debió hacer?",
				correctionPlaceholder: "Ej.: dio la dirección de Quito cuando le pregunté por Elizabeth; debió consultar Oficinas con Elizabeth, New Jersey.",
				analyzing: "Analizando la conversación y el prompt…",
				diagnosis: "Qué pasó",
				target: "Cambio en",
				targetSelf: "este agente ({{name}})",
				targetSpecialist: "el especialista {{name}}",
				cancel: "Cancelar",
				retry: "Volver a la corrección",
				analyze: "Proponer cambio",
				applyDraft: "Aplicar al borrador",
				saveSpecialist: "Guardar en {{name}}",
			},
			knowledge: {
				editHelp: "Compare lo que dice el PDF con lo que entendió el agente. Corrija la derecha si algo no coincide y quite las reglas que sobran.",
				imageNotice: "Este texto se leyó de una imagen del PDF. Revíselo con más cuidado: pueden escaparse letras o números.",
				editTitle: "Revisar: {{section}}",
				editHelp: "Compare cada regla con el PDF. Si algo no coincide, corríjalo en la columna de la derecha; quite las que sobran. Cuando esté bien, toque \"Guardar y aprobar\".",
				inPdf: "En el PDF",
				agentWillKnow: "Lo que sabrá el agente",
				organization: "Dónde se ubica (opcional)",
				pathPlaceholder: "Ej.: Ecuador › Paquetería › Impuestos",
				removeRule: "Quitar esta regla",
				saveAndApprove: "Guardar y aprobar",
				entrySavedApproved: "Registro guardado y aprobado",
				promptTab: {
					whenToUse: "Cuándo debe consultarlo este agente",
					whenToUsePlaceholder: "Ej.: Cuando pregunten por la historia de Teresa y Jorge, sus personajes o lo que les pasa.",
					missingUsage: "Escriba cuándo usar cada documento activado.",
					unsaved: "Cambios sin guardar",
					tab: "Conocimiento",
					title: "Documentos que este agente puede consultar",
					help: "Active los documentos que este agente puede consultar y escriba, para cada uno, cuándo debe hacerlo. Solo aparecen los documentos publicados.",
					empty: "Aún no hay documentos publicados. Súbalos y publíquelos en Base de conocimiento.",
					document: "Documento",
					version: "Versión publicada",
					rules: "Reglas",
					use: "Usar",
					saved: "Conocimiento del agente actualizado",
				},
				publish: {
					button: "Publicar ({{count}} reglas)",
					republish: "Volver a publicar",
					unpublish: "Despublicar",
					title: "Publicar en la base de conocimiento",
					summary: "Se publicarán {{count}} reglas aprobadas. El agente {{agent}} podrá consultarlas con la herramienta \"consultar_base_de_conocimiento\", que se agrega sola. Lo pendiente y lo rechazado no se publica.",
					replaceNotice: "Reemplaza lo que estaba publicado de este documento.",
					confirm: "Publicar",
					publishing: "Publicando…",
					done: "{{count}} reglas publicadas",
					unpublished: "Documento despublicado: el agente ya no lo consulta",
					banner: "Publicado: {{count}} reglas · {{date}}",
					pendingChanges: "Hay cambios sin publicar",
				},
				costLabel: "costó ${{cost}}",
				statusTabs: {
					pending: "Pendientes",
					approved: "Aprobados",
					rejected: "Rechazados",
				},
				optional: "Opcional",
				tagsPlaceholder: "Escriba y presione Enter",
				title: "Base de conocimiento",
				uploadButton: "Subir PDF",
				uploadTitle: "Subir documento",
				chooseFile: "Elegir archivo PDF",
				name: "Nombre",
				namePlaceholder: "Ej. Manual de Servicios (si lo deja vacío se usa el nombre del archivo)",
				uploadHint: "Se procesa con la clave de OpenAI de sus agentes, alrededor de $1 por un manual de 60 páginas. Si sube una nueva versión con el mismo nombre, queda como v2, v3… y los agentes que lo usan la toman sola al publicarla.",
				emptyState: {
					title: "Enséñele a su agente lo que tiene que saber",
					subtitle: "La base de conocimiento es la información que el agente consulta para responder a los clientes: reglas, requisitos, horarios, políticas. Elija cómo empezar.",
					aiTitle: "Crear con IA",
					aiText: "Dígale el tema o adjunte un manual. La IA le hace preguntas hasta que cada dato quede claro y arma el texto por usted.",
					pdfTitle: "Subir un PDF",
					pdfText: "Si ya tiene un documento ordenado y claro, súbalo y la IA lo convierte en reglas para que usted las revise.",
				},
				manual: {
					button: "Crear con IA",
					title: "Escribir a mano",
					editTitle: "Editar texto",
					namePlaceholder: "Nombre del documento, ej. Reglas EEUU → Ecuador",
					startTitle: "¿Qué quiere que sepa el agente?",
					startHint: "Escríbalo con sus palabras o adjunte un manual. Le voy a hacer preguntas hasta que cada dato quede claro, y voy armando el texto por usted.",
					writeMyself: "Prefiero escribir el texto yo mismo",
					draftTitle: "Lo que va a saber el agente",
					draftEmpty: "Todavía está vacío. Responda las preguntas del asistente y aquí se va armando el texto.",
					editHint: "Un dato por línea. Los títulos empiezan con #. Cada línea debe entenderse sola.",
					save: "Guardar y procesar",
					saving: "Guardando…",
					saved: "Texto guardado. Se está procesando.",
					source: "Escrito a mano",
					editText: "Editar texto",
					inText: "En el texto",
					assistantIntro: "Puede elegir un tema, escribir el suyo o adjuntar un manual (PDF o TXT) con el clip.",
					attachSource: "Adjuntar un manual (PDF o TXT)",
					sourceGoal: "Armar la información a partir del manual \"{{name}}\"",
					sourceTruncated: "{{name}} (muy largo: solo se usa la primera parte)",
					goalPlaceholder: "Ej. Los horarios de cada oficina y los días que cierran",
					answerPlaceholder: "Escriba su respuesta…",
					suggestions: {
						s1: "Horarios y días de cierre de las oficinas",
						s2: "Preguntas frecuentes de los clientes",
						s3: "Requisitos para un trámite",
						s4: "Políticas de reclamos y devoluciones",
					},
				},
				upload: "Subir y procesar",
				uploading: "Subiendo…",
				uploaded: "Documento subido. Se está procesando.",
				cancel: "Cancelar",
				save: "Guardar",
				deleted: "Documento eliminado",
				deleteTitle: "¿Eliminar {{name}}?",
				deleteMessage: "Se eliminan el PDF y todos sus registros extraídos. Esta acción no se puede deshacer.",
				empty: "Aún no hay documentos.",
				review: "Revisar",
				delete: "Eliminar",
				reprocess: "Volver a procesar",
				approveClean: "Aprobar los que no tienen alertas ({{count}})",
				approvedClean: "{{count}} registros aprobados",
				approve: "Aprobar",
				reject: "Rechazar",
				undoReview: "Volver a pendiente",
				edit: "Editar",
				entrySaved: "Registro actualizado",
				rule: "Regla",
				rulesCount: "{{count}} reglas",
				page: "pág.",
				pagesCount: "{{count}} páginas",
				reviewProgress: "{{approved}} de {{total}} aprobados",
				noCountry: "Sin país",
				noEntries: "No hay registros con estos filtros.",
				verified: "Verificado: la cita aparece tal cual en el PDF",
				notVerified: "Sin verificar: revise este dato contra el PDF",
				columns: {
					path: "Ubicación en el documento",
					tags: "Etiquetas",
					section: "Sección",
					name: "Nombre",
					version: "Versión",
					status: "Estado",
					review: "Revisión",
					alerts: "Alertas",
					cost: "Costo",
					date: "Fecha",
					actions: "Acciones",
					country: "País",
					content: "Contenido",
					pages: "Páginas",
				},
				documentStatus: {
					processing: "Procesando",
					review: "En revisión",
					failed: "Falló",
					published: "Publicado",
				},
				entryStatus: {
					pending: "Pendiente",
					approved: "Aprobado",
					rejected: "Rechazado",
				},
				progress: {
					queued: "En cola…",
					reading: "Leyendo el documento…",
					images: "Leyendo las imágenes: {{done}} de {{total}}",
					outline: "Identificando las secciones por país…",
					extracting: "Extrayendo la información: {{done}} de {{total}} partes",
					validating: "Validando cada dato contra el documento…",
				},
				summary: {
					total: "{{count}} registros",
					withAlerts: "{{count}} con alertas",
					pending: "{{count}} pendientes",
					approved: "{{count}} aprobados",
					rejected: "{{count}} rechazados",
				},
				report: {
					inconsistencies: "Contradicciones encontradas en el documento",
					warnings: "Avisos del procesamiento",
				},
				filters: {
					onlyAlertsCount: "Con alertas ({{count}})",
					all: "Todos",
					search: "Buscar",
					onlyAlerts: "Solo con alertas",
				},
				alerts: {
					QUOTE_NOT_FOUND: "La cita no aparece en el PDF",
					NUMBER_NOT_IN_SOURCE: "Un número no está en la cita",
					IMAGE_ONLY: "Leído de una imagen: verifíquelo",
					PAGE_OUT_OF_RANGE: "Página inválida",
				},
			},
			promptTestChat: {
				thinking: "Pensando…",
				usedTools: "Consultó {{names}}",
				sent: "Envió",
				returned: "Respuesta",
				noResult: "(sin respuesta)",
				kinds: {
					specialist: "Especialista",
					webhook: "Herramienta",
					transfer: "Transferencia",
				},
				voiceTypePlaceholder: "Escríbale durante la llamada (por ejemplo, un número de guía)…",
				discardedSilence: "(silencio o ruido: no se respondió)",
				discardedNoise: "(ruido descartado: \"{{text}}\")",
				discardedKeywords: "(descartado, solo palabras clave, posible fantasma: \"{{text}}\")",
				discardedDuringTool: "(ignorado mientras consultaba: \"{{text}}\")",
				connectionUsed: "Usa la configuración de la conexión: {{name}}",
				correct: "Corregir",
				coachApplied: "Se aplicó la corrección al borrador (sin guardar). Repita la conversación para probarla y, si le convence, guarde.",
				coachSavedSpecialist: "Se guardó una nueva versión de {{name}}. Repita la conversación para probarla.",
				replay: "Repetir conversación",
				silenceWarning: "Silencio: se preguntó si sigue en la línea.",
				silenceHangup: "Llamada cerrada: nadie respondió tras preguntar si seguía en la línea.",
				maxDurationReached: "Llamada cerrada por la duración máxima configurada.",
				title: "Probar agente",
				newChat: "Nuevo chat",
				draft: "Borrador sin guardar",
				draftHelp: "Está probando el texto que tiene en el editor, aunque todavía no lo haya guardado.",
				mode: {
					text: "Responde como en un chat de WhatsApp, con sus especialistas y herramientas reales.",
					voice: "Responde como en una llamada (en texto), con el modelo de voz.",
					specialist: "Le pregunta directo al especialista, como si lo consultara el agente principal.",
				},
				empty: "Escriba un mensaje como si fuera el cliente. Las transferencias son simuladas: no se crea ningún ticket.",
				saveFirst: "Guarde el agente para poder probarlo.",
				you: "Cliente",
				agent: "Agente",
				silent: "(el agente no respondió nada)",
				error: "(error: {{error}})",
				transferred: "La conversación se transfirió a un asesor (simulado).",
				hungUp: "El agente colgó la llamada (simulado).",
				placeholder: "Escriba su mensaje…",
				endedPlaceholder: "La conversación terminó. Empiece un nuevo chat.",
				emptyVoice: "Presione \"Llamar\" y hable como si fuera el cliente. Las transferencias son simuladas.",
				voiceError: "Hubo un error en la llamada de prueba.",
				voiceStartError: "No se pudo iniciar la llamada de prueba: {{error}}",
				status: {
					idle: "Sin llamada",
					connecting: "Conectando…",
					listening: "Escuchando",
					thinking: "Pensando…",
					speaking: "Hablando",
				},
				mute: "Silenciar",
				unmute: "Activar micrófono",
				startCall: "Llamar",
				endCall: "Colgar",
				modeText: "Texto",
				modeVoice: "Voz",
				voiceUnavailable: "los especialistas se prueban solo por texto",
				voiceHint: "Use auriculares para evitar eco",
				enterHint: "Enter para enviar · Shift+Enter para salto de línea",
			},
			aiReviewBanner: {
				question: "La IA atendió este chat antes de llegar a usted. ¿Lo hizo bien?",
				good: "Bien",
				problem: "Con problema",
				later: "Calificar después",
				thanks: "¡Gracias! Su calificación ayuda a mejorar la IA.",
				dialogTitle: "¿Qué hizo mal la IA?",
				dialogHelp: "Elija el motivo principal. Si quiere, agregue un detalle.",
				comment: "Detalle (opcional)",
				commentPlaceholder: "Ej.: le dio la dirección de otra oficina",
				cancel: "Cancelar",
				send: "Enviar",
				reasons: {
					wrongInfo: "Dio información incorrecta",
					misunderstood: "No entendió al cliente",
					lateTransfer: "Transfirió tarde",
					needlessTransfer: "Transfirió sin necesidad",
					tone: "Tono inadecuado",
					other: "Otro",
				},
			},
			aiAssistant: {
				dictate: "Dictar por voz",
				stopDictation: "Terminar y escribir lo que dije",
				listening: "Escuchando… pulse el botón rojo para terminar",
				transcribing: "Escribiendo lo que dijo…",
				micDenied: "No se pudo usar el micrófono. Revise el permiso del navegador para este sitio.",
				editDraft: "Editar",
				doneEditing: "Listo",
				restart: "Empezar de nuevo",
				thinking: "Pensando…",
				start: "Empezar",
				send: "Enviar",
			},
			promptBuilder: {
				createButton: "Crear con IA",
				improveButton: "Mejorar con IA",
				createTitle: "Crear agente con IA",
				improveTitle: "Mejorar agente con IA",
				apply: "Usar este prompt",
				applied: "Prompt aplicado en el editor. Revíselo y guarde.",
				startTitle: "¿Qué tiene que hacer este agente?",
				startHint: "Descríbalo con sus palabras. No le voy a dar la razón en todo: si algo es ambiguo, contradictorio o no es válido para una IA, se lo voy a decir y no lo voy a poner hasta que quede claro.",
				writeMyself: "Prefiero escribir el prompt yo mismo",
				assistantIntro: "Dígame qué quiere cambiar o pídame que revise el prompt. Voy a cuestionar cada pedido hasta que quede claro y estable.",
				goalPlaceholder: "Ej. Un agente que agende citas para recoger paquetes a domicilio",
				answerPlaceholder: "Escriba su respuesta…",
				draftTitle: "Prompt del agente",
				draftEmpty: "Todavía está vacío. Responda las preguntas y aquí se va armando el prompt.",
				editHint: "Puede corregirlo a mano. Al terminar use \"Usar este prompt\" y luego guarde en el editor.",
				suggestions: {
					s1: "Un agente que responda preguntas frecuentes",
					s2: "Un agente que agende citas",
					s3: "Un especialista en un tema puntual",
					review: "Revise el prompt actual y dígame qué está mal",
					shorter: "Hágalo más corto sin perder reglas",
					transfer: "Defina bien cuándo transferir a un asesor",
				},
			},
			testing: {
				title: "Pruebas",
				tabs: {
					textCases: "Casos de prueba (texto)",
					callCases: "Casos de prueba (llamada)",
					avatar: "Avatar de voz",
				},
				common: {
					loading: "Cargando…",
					loadingConnections: "Cargando conexiones…",
					noPrompt: "Esta conexión no tiene un prompt asignado.",
					edit: "Editar",
					delete: "Borrar",
					cancel: "Cancelar",
					save: "Guardar",
				},
				hints: {
					webhookAuth: "El webhook rechazó la autenticación. Revise la URL en la pestaña Herramientas del prompt.",
					specialistApiKey: "Ponga la clave de API real del especialista en Prompts → ese prompt → Clave de API. Cada especialista usa la suya, no la del prompt padre.",
					quota: "La cuenta de OpenAI superó su cuota o su límite de frecuencia. Revise el saldo en platform.openai.com.",
					timeout: "El webhook no contestó a tiempo. Pruebe la URL por fuera y verifique que responda en menos de 10 segundos.",
					blockedUrl: "La URL apunta a una red privada o a localhost, y el backend no llega ahí. Tiene que ser una URL pública o un túnel.",
					serverError: "El servidor del webhook falló. El problema está de ese lado, no en el prompt.",
				},
				trace: {
					sends: "envía",
					noParams: "(sin parámetros)",
					goesTo: "va a",
					model: "modelo",
					error: "error",
					fix: "solución",
					returns: "devuelve",
					noAnswer: "(sin respuesta)",
					raw: "crudo · {{count}} caracteres",
					tool: "herramienta",
					webhook: "webhook",
					specialist: "especialista",
				},
				avatar: {
					states: {
						idle: "En espera",
						listening: "Escuchando",
						thinking: "Pensando",
						speaking: "Hablando",
						error: "Error",
					},
					sensitivity: {
						high: "Sin ruido",
						medium: "Normal",
						low: "Ruidoso",
					},
					noConnections: "No hay conexiones de avatar de voz todavía. Cree una en Conexiones → Nueva conexión → Avatar y configúrele el modelo 3D y el prompt.",
					connection: "Conexión a probar",
					start: "Iniciar",
					stop: "Terminar",
					thresholdChip: "Umbral: {{value}}",
					disabled: "Esta conexión está deshabilitada.",
					frameTitle: "Llamada de prueba del avatar",
					startHint: "Presione Iniciar y la llamada se abre aquí mismo. El micrófono se pide dentro de este recuadro.",
					legend: {
						listening: "Escuchando",
						speaking: "Habla el avatar",
						thinking: "Pensando",
						threshold: "Umbral de voz",
					},
					metrics: {
						noise: "Ruido de fondo",
						noiseNote: "con nadie hablando",
						peak: "Pico de su voz",
						peakNote: "p90 al hablar",
						echo: "Eco del avatar",
						echoNote: "{{percent}}% del umbral",
						echoEmpty: "hable con él primero",
						margin: "Margen voz/ruido",
						marginNote: "menos de 4x es poco",
						turns: "Turnos detectados",
						turnsNote: "cortes por silencio",
						avgTurn: "Duración media",
						avgTurnNote: "de cada turno suyo",
					},
					echo: {
						high: "Hay eco: mientras el avatar habla, su propia voz entra por el micrófono por encima del umbral. El avatar se va a interrumpir solo. Use auriculares, baje el volumen del parlante o suba el umbral.",
						edge: "Eco al límite: la voz del avatar entra por el micrófono cerca del umbral. En un ambiente un poco más ruidoso puede empezar a interrumpirse solo.",
						none: "Sin eco relevante: lo que entra mientras el avatar habla queda muy por debajo del umbral.",
					},
					audioBlocked: "El navegador bloqueó la reproducción del audio ({{reason}}). El avatar responde pero no se escucha. En Brave suele ser el escudo de reproducción automática: abra el ícono del león → Configuración avanzada → permitir reproducción automática en este sitio.",
					audioBlockedLog: "el navegador bloqueó la reproducción del audio ({{reason}})",
					unknown: "desconocido",
					userTurnLog: "turno del usuario → {{seconds}} s",
					agentTree: "Árbol de agentes",
					whoAvatar: "avatar",
					whoYou: "usted",
				},
				scenarios: {
					connection: "Conexión",
					stopAll: "Detener",
					queued: "En cola",
					chatting: "Conversando",
					calling: "En llamada",
					step: "mensaje {{current}} de {{total}}",
					runProgress: "Caso {{position}} de {{total}} · {{title}}",
					runAll: "Correr todos",
					newCase: "Nuevo caso",
					running: "Corriendo…",
					evaluating: "Evaluando con IA…",
					passCount: "{{count}} bien",
					failCount: "{{count}} mal",
					passed: "Pasó",
					failed: "Falló",
					automatic: "(automático)",
					run: "Correr",
					columns: {
						case: "Caso",
						status: "Estado",
					},
					empty: "Todavía no hay casos de prueba. Cree uno con \"Nuevo caso\": qué escribe el cliente y qué debe hacer la IA.",
					noTextConnections: "No hay conexiones Sandbox. Cree una en Conexiones → Nueva conexión → Sandbox y asígnele el prompt que quiere poner a prueba.",
					noCallConnections: "No hay conexiones de central telefónica (SIP). Cree una en Conexiones y asígnele el prompt de llamada que quiere poner a prueba.",
					viewConversation: "Ver conversación",
					copyDebug: "Copiar el detalle de toda esta conversación (para preguntarle a una IA qué opina)",
					debugCopied: "Detalle copiado.",
					copyFailed: "No se pudo copiar.",
					confirmDelete: "¿Borrar el caso \"{{title}}\"?",
					expectedLabel: "Se espera:",
					showMore: "Ver más",
					showLess: "Ver menos",
					notRunYet: "Todavía no se corrió este caso.",
					turn: "Turno {{number}}",
					customer: "Cliente",
					aiReply: "Respuesta de la IA",
					ranTool: "Ejecutó esta herramienta",
					ranTools: "Ejecutó estas herramientas",
					callTransferred: "(la llamada ya se transfirió a un asesor)",
					chatTransferred: "(la conversación ya se transfirió a un asesor)",
					callHungUp: "(la IA ya colgó la llamada)",
					aiSilent: "(la IA no dijo nada)",
					noPromptReply: "(esta conexión no tiene un prompt configurado)",
					errorReply: "(error: {{error}})",
					evalFailed: "No se pudo evaluar automáticamente. Júzguelo a mano.",
				},
				form: {
					newTitle: "Nuevo caso de prueba",
					editTitle: "Editar caso",
					title: "Título",
					titlePlaceholder: "Ej. Pregunta por Miami y luego por Orlando",
					category: "Categoría",
					customerWrites: "El cliente escribe",
					customerWritesHint: "Un mensaje por cuadro, en el orden en que el cliente los manda. La IA responde a cada uno antes del siguiente.",
					firstMessagePlaceholder: "Ej. ¿Dónde queda la oficina de Miami?",
					nextMessagePlaceholder: "Siguiente mensaje del cliente",
					addMessage: "Agregar otro mensaje",
					removeMessage: "Quitar este mensaje",
					aiShould: "La IA debe",
					aiShouldHint: "Qué tiene que hacer o decir la IA para que el caso pase. Otra IA lo juzga con esto, así que sea concreto.",
					aiShouldPlaceholder: "Ej. Dar la dirección de Miami, y cuando pregunta por Orlando decir que ahí no hay oficina, sin transferir.",
					moreOptions: "Más opciones",
					phone: "Teléfono del cliente (opcional)",
					phonePlaceholder: "Vacío = se usa un número de prueba inventado",
					phoneHelpText: "Si el caso depende de datos reales (rastreo por teléfono, por ejemplo), ponga aquí un número real para que la búsqueda encuentre algo de verdad.",
					phoneHelpCall: "Es el número desde el que \"llama\" el cliente. Si el caso depende de datos reales (rastreo por teléfono, por ejemplo), ponga un número real.",
				},
				filters: {
					search: "Buscar un caso…",
					all: "Todos ({{count}})",
					fail: "Fallaron ({{count}})",
					pass: "Pasaron ({{count}})",
					pending: "Sin correr ({{count}})",
					noResults: "Ningún caso coincide con la búsqueda o el filtro.",
				},
				groups: {
					uncategorized: "Sin categoría",
					summary: "{{passed}} de {{total}} pasaron",
					failedCount: "{{count}} fallaron",
					run: "Correr grupo ({{count}})",
					runFiltered: "Correr {{count}} filtrados",
				},
				debug: {
					case: "Caso: {{title}}",
					expected: "Se espera: {{expected}}",
					verdict: "Veredicto: {{verdict}}",
					verdictAuto: "Veredicto (automático): {{verdict}}",
					reason: "Razón: {{reason}}",
					turn: "--- Turno {{number}} ---",
					customer: "Cliente: {{text}}",
					ai: "IA: {{text}}",
					toolsCalled: "Herramientas llamadas en este turno:",
					result: "Resultado",
					noTools: "(No se llamó ninguna herramienta en este turno.)",
					question: "¿Qué opina, esto está bien o está mal, y por qué?",
				},
			},
			queueIntegration: {
				title: "Integraciones",
				table: {
					id: "ID",
					type: "Tipo",
					name: "Nombre",
					projectName: "Nombre del Proyecto",
					language: "Idioma",
					lastUpdate: "Última actualización",
					actions: "Acciones",
				},
				buttons: {
					add: "Agregar Proyecto",
				},
				searchPlaceholder: "Buscar...",
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage:
						"¿Estás seguro? ¡Esta acción no se puede deshacer! y será eliminada de los Departamentos y conexiones vinculadas",
				},
			},
			notifications: {
				noTickets: "Sin notificaciones.",
			},
			plans: {
				form: {
					name: "Nombre",
					users: "Usuarios",
					connections: "Conexiones",
					campaigns: "Campañas",
					schedules: "Agendamientos",
					enabled: "Habilitado",
					disabled: "Deshabilitado",
					clear: "Limpiar",
					delete: "Eliminar",
					save: "Guardar",
					no: "No",
					yes: "Sí",
					money: "$",
				},
			},
			auditor: {
				title: "Auditoria",
				filters: {
					from: "Desde",
					to: "Hasta",
					filter: "Filtrar",
				},
				kpis: {
					totalAudits: "Total auditorías",
					agentsAudited: "Agentes auditados",
					aiClients: "Clientes IA",
					avgUser: "Prom. usuario",
					avgAi: "Prom. IA",
					userAuditsSuffix: "aud. usuario",
					aiAuditsSuffix: "aud. IA",
				},
				distribution: {
					title: "Distribución global",
					verySatisfied: "Muy sat.",
					satisfied: "Sat.",
					neutral: "Neutral",
					unsatisfied: "Insat.",
					veryUnsatisfied: "Muy insat.",
				},
				classification: {
					spam: "Spam 🚫",
					noReply: "Sin respuesta 📵",
					escalated: "Escalado ⚠️",
					recurring: "Reincidente 🔁",
					unclassified: "Sin clasificar ❓",
					noRating: "Sin calificación",
				},
				tabs: {
					user: "Usuario",
					ai: "IA",
				},
				table: {
					agent: "Agente",
					client: "Cliente",
					rating: "Calificación",
					auditsTickets: "Aud. / Tickets",
					type: "Tipo",
					lastAudit: "Última aud.",
					view: "Ver",
					ticketsBtn: "Tickets",
					aiChip: "IA",
					empty: "Sin auditorías en el período seleccionado",
				},
			},
			callCommon: {
				outcomes: {
					hangup: "Colgada",
					socketError: "Error en la llamada",
					noPrompt: "Rechazada (sin voz configurada)",
					serverError: "Error del servidor",
					transferred: "Transferida a un asesor",
				},
				sentiments: {
					verySatisfied: "Muy satisfecho",
					satisfied: "Satisfecho",
					dissatisfied: "Insatisfecho",
					veryDissatisfied: "Muy insatisfecho",
				},
				transferStatus: {
					answer: "Contestada",
					busy: "Ocupado",
					noAnswer: "Nadie atendió",
					cancel: "Cancelada",
					congestion: "Congestión / línea caída",
					chanUnavail: "Número no disponible",
				},
				transferResult: {
					unconfirmed: "Transferida (sin confirmar)",
					answered: "Transferida y contestada",
					notAnswered: "No contestada ({{status}})",
				},
			},
			callHistory: {
				filterAll: "Todos",
				auditFilter: "Auditoría",
				auditAudited: "Auditadas",
				auditPending: "Sin auditar",
				auditedBy: "Auditado por {{name}}",
				title: "Historial",
				allDates: "Todas las fechas",
				dateFrom: "Desde",
				dateTo: "Hasta",
				clear: "Limpiar",
				apply: "Aplicar",
				filters: "Filtros",
				actions: "Acciones",
				exportCsv: "Exportar CSV",
				outcome: "Resultado",
				allOutcomes: "Todos",
				fromLabel: "De (quién llamó)",
				toLabel: "A (número marcado)",
				pageInfo: "Página {{page}} de {{totalPages}} · Total: {{total}}",
				perPage: "{{count}} / página",
				columns: {
					date: "Fecha",
					duration: "Duración",
					cost: "Costo",
					direction: "Dirección",
					from: "De",
					to: "A",
					connection: "Conexión",
					resolved: "¿Resolvió?",
					sentiment: "Sentimiento",
					outcome: "Resultado",
				},
				inbound: "Entrante",
				yes: "Sí",
				no: "No",
				emptyNoFilters: "Todavía no hay llamadas registradas.",
				emptyFiltered: "Ninguna llamada coincide con estos filtros.",
			},
			callMetrics: {
				title: "Métricas",
				apply: "Aplicar",
				periods: {
					today: "Hoy",
					yesterday: "Ayer",
					thisWeek: "Esta semana",
					lastWeek: "Semana pasada",
					thisMonth: "Este mes",
					lastMonth: "Mes pasado",
					custom: "Personalizado",
				},
				tiles: {
					calls: "Llamadas",
					successRate: "Tasa de éxito",
					resolvedRate: "Resuelto por la IA",
					cost: "Costo estimado",
					knownContacts: "De contactos conocidos",
				},
				tooltips: {
					successRate: "De todas las llamadas, cuántas terminaron colgando normalmente -- sin error técnico ni ser rechazadas por falta de voz configurada. No mide si el cliente quedó conforme, solo que la llamada en sí no falló.",
					resolvedRate: "De las llamadas que la IA analizó después de colgar (leyendo la transcripción), en cuántas considera que de verdad resolvió o avanzó lo que el cliente necesitaba. Es un indicador de calidad real, no solo de que la llamada no se cortó.",
				},
				callsPerDayTitle: "Llamadas por día · {{range}} ({{days}} días)",
				legend: {
					resolved: "Resuelta por la IA",
					notResolved: "No resuelta",
					notAnalyzed: "Sin analizar",
				},
				emptyNoCallsInRange: "Todavía no hay llamadas en este rango.",
				transfersTitle: "Transferencias: {{count}}",
				transferLabels: {
					answered: "Contestadas",
					notAnswered: "No contestadas",
				},
				emptyNoTransfers: "Ninguna transferencia en este rango.",
				sentimentTitle: "Satisfacción del cliente",
				satisfiedCenterLabel: "Satisfechos",
				emptyNoAnalyzed: "Ninguna llamada analizada todavía.",
				durationTitle: "Duración de las llamadas",
				specialistTitle: "Qué especialista atendió",
				noSpecialist: "Sin especialista (transferencia directa)",
				emptyNoData: "Sin datos todavía.",
			},
			whatsappManager: {
				title: "Analítica de WhatsApp",
				cards: {
					sent: "Enviados",
					pending: "Pendientes",
					failed: "Fallidos",
					multimedia: "Multimedia",
				},
				filters: {
					from: "Desde",
					to: "Hasta",
					connection: "Conexión",
					number: "Número",
					numberPlaceholder: "Ej: +593...",
					status: "Estado",
					priority: "Prioridad",
					content: "Contenido del mensaje",
					contentPlaceholder: "Buscar en el texto...",
					all: "Todos",
					today: "Hoy",
					last7: "Últimos 7 días",
					last30: "Últimos 30 días",
					clear: "Limpiar",
					apply: "Aplicar filtros",
				},
				status: {
					sent: "Enviado",
					pending: "Pendiente",
					failed: "Fallido",
				},
				priority: {
					high: "Alta",
					medium: "Media",
					low: "Baja",
				},
				table: {
					origin: "Origen",
					destination: "Destino",
					status: "Estado",
					priority: "Prioridad",
					date: "Fecha",
					message: "Mensaje",
					actions: "Acciones",
					viewDetails: "Ver detalles",
					retry: "Reintentar envío",
				},
				empty: {
					title: "No hay resultados con los filtros actuales",
					subtitle: "Ajusta los filtros o intenta con “Últimos 30 días”.",
				},
				detail: {
					title: "Detalles de envío",
					number: "Número",
					author: "Autor",
					whatsapp: "WhatsApp",
					date: "Fecha",
					status: "Estado",
					priority: "Prioridad",
					detail: "Detalle",
					message: "Mensaje",
					noError: "Sin detalle de error.",
					unknown: "Desconocido",
					close: "Cerrar",
					retry: "Reintentar",
				},
				toasts: {
					retrying: "Reintentando envío…",
					retryError: "No se pudo reintentar el envío.",
					loadError: "Error al obtener datos.",
				},
			},
			messagesAPI: {
				title: "API",
				textMessage: {
					number: "Número",
					body: "Mensaje",
					token: "Token registrado",
				},
				mediaMessage: {
					number: "Número",
					body: "Nombre del archivo",
					media: "Archivos",
					token: "Token registrado",
				},
			},
			quickMessages: {
				title: "Respuestas Rápidas",
				buttons: {
					add: "Nueva Respuesta",
				},
				dialog: {
					shortcode: "Atajo",
					message: "Respuesta",
				},
			},
			templateMessage: {
				title: "Plantillas de Mensajes",
				buttons: {
					add: "Añadir Nueva Plantilla",
				},
				dialog: {
					name: "Nombre",
					status: "Estado",
					message: "Mensaje",
					language: "Idioma",
					addVariable: "Agregar Variable",
				},
			},
			contactLists: {
				title: "Listas de Contactos",
				table: {
					name: "Nombre",
					contacts: "Contactos",
					isvalidated: "Válidos",
					isNotValidated: "No válidos",
					actions: "Acciones",
				},
				buttons: {
					add: "Nueva Lista",
				},
				dialog: {
					name: "Nombre",
					company: "Empresa",
					okEdit: "Editar",
					okAdd: "Agregar",
					add: "Agregar",
					edit: "Editar",
					cancel: "Cancelar",
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage: "Esta acción no se puede revertir.",
				},
				toasts: {
					deleted: "Registro eliminado",
				},
			},
			contactListItems: {
				title: "Contactos",
				searchPlaceholder: "Buscar",
				buttons: {
					add: "Nuevo",
					lists: "Listas",
					import: "Importar",
				},
				dialog: {
					name: "Nombre",
					number: "Número",
					whatsapp: "Whatsapp",
					email: "E-mail",
					okEdit: "Editar",
					okAdd: "Agregar",
					add: "Agregar",
					edit: "Editar",
					cancel: "Cancelar",
				},
				table: {
					name: "Nombre",
					number: "Número",
					whatsapp: "Whatsapp",
					email: "E-mail",
					actions: "Acciones",
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage: "Esta acción no se puede revertir.",
					importMessage: "¿Quieres importar los contactos de esta hoja de cálculo?",
					importTitlte: "Importar",
				},
				toasts: {
					deleted: "Registro eliminado",
				},
			},
			campaigns: {
				title: "Campañas",
				searchPlaceholder: "Buscar",
				buttons: {
					add: "Nueva Campaña",
					contactLists: "Listas de Contactos",
				},
				table: {
					name: "Nombre",
					whatsapp: "Conexión",
					contactList: "Lista de Contactos",
					status: "Estado",
					scheduledAt: "Programada para",
					completedAt: "Finalizada",
					confirmation: "Confirmación",
					actions: "Acciones",
				},
				dialog: {
					new: "Nueva Campaña",
					update: "Editar Campaña",
					readonly: "Ver",
					form: {
						name: "Nombre",
						message1: "Mensaje 1",
						message2: "Mensaje 2",
						message3: "Mensaje 3",
						message4: "Mensaje 4",
						message5: "Mensaje 5",
						confirmationMessage1: "Mensaje de confirmación 1",
						confirmationMessage2: "Mensaje de confirmación 2",
						confirmationMessage3: "Mensaje de confirmación 3",
						confirmationMessage4: "Mensaje de confirmación 4",
						confirmationMessage5: "Mensaje de confirmación 5",
						messagePlaceholder: "Contenido del mensaje",
						whatsapp: "Conexión",
						status: "Estado",
						scheduledAt: "Programada para",
						confirmation: "Confirmación",
						timezone: "Zona horaria",
						template: "Plantilla",
						contactList: "Lista de Contactos",
					},
					buttons: {
						add: "Agregar",
						edit: "Actualizar",
						okadd: "Ok",
						cancel: "Cancelar",
						restart: "Reiniciar",
						close: "Cerrar",
						attach: "Adjuntar Archivos",
					},
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage: "Esta acción no se puede revertir.",
				},
				toasts: {
					success: "Operación realizada con éxito",
					cancel: "Campaña cancelada",
					restart: "Campaña reiniciada",
					deleted: "Registro eliminado",
				},
			},
			announcements: {
				title: "Informativos",
				searchPlaceholder: "Buscar",
				buttons: {
					add: "Nuevo Informativo",
					contactLists: "Listas de Informativos",
				},
				table: {
					priority: "Prioridad",
					title: "Título",
					text: "Texto",
					mediaName: "Archivos",
					status: "Estado",
					actions: "Acciones",
				},
				dialog: {
					edit: "Edición de Informativo",
					add: "Nuevo Informativo",
					update: "Editar Informativo",
					readonly: "Solo Visualización",
					form: {
						priority: "Prioridad",
						title: "Título",
						text: "Texto",
						mediaPath: "Archivos",
						status: "Estado",
					},
					buttons: {
						add: "Agregar",
						edit: "Actualizar",
						okadd: "Ok",
						cancel: "Cancelar",
						close: "Cerrar",
						attach: "Adjuntar archivos",
					},
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage: "Esta acción no se puede revertir.",
				},
				toasts: {
					success: "Operación realizada con éxito",
					deleted: "Registro eliminado",
				},
			},
			campaignsConfig: {
				title: "Configuración de Campañas",
			},
			helps: {
				general: "General",
				overline: "Ayuda · {{section}}",
				counter: "Video {{current}} de {{total}}",
				playing: "Reproduciendo",
				previous: "Anterior",
				next: "Siguiente",
				noVideo: "Este tema no tiene video.",
				empty: "Todavía no hay videos de ayuda.",
				title: "Central de Ayuda",
			},
			schedules: {
				title: "Agendamientos",
				confirmationModal: {
					deleteTitle: "¿Estás seguro de que deseas eliminar este programa?",
					deleteMessage: "Esta acción no se puede revertir.",
				},
				table: {
					contact: "Contacto",
					body: "Mensaje",
					sendAt: "Fecha programada",
					sentAt: "Fecha de envío",
					status: "Estado",
					actions: "Acciones",
				},
				buttons: {
					add: "Nuevo Agendamiento",
					retry: "Reintentar",
				},
				toasts: {
					deleted: "Programación eliminada exitosamente.",
					retry: "Agendamiento reencolado para envío.",
				},
			},
			tags: {
				title: "Tags",
				confirmationModal: {
					deleteTitle: "¿Estás seguro de que deseas eliminar esta etiqueta?",
					deleteMessage: "Esta acción no se puede revertir.",
				},
				table: {
					name: "Nombre",
					color: "Color",
					tickets: "Registros",
					actions: "Acciones",
				},
				buttons: {
					add: "Nuevo Tag",
				},
				toasts: {
					deleted: "Etiqueta eliminada correctamente.",
				},
			},
			uploads: {
				titles: {
					titleUploadMsgDragDrop: "ARRASTRA Y SUELTA ARCHIVOS EN EL CAMPO A CONTINUACIÓN",
					titleFileList: "Lista de archivo(s)",
				},
			},
			queues: {
				title: "Departamentos & ChatBot",
				table: {
					name: "Nombre",
					color: "Color",
					greeting: "Mensaje de saludo",
					actions: "Acciones",
					orderQueue: "Orden de la Fila (bot)",
					group: "Grupo",
					automation: "Automatización",
					automationPrompt: "IA",
					automationIntegration: "Integración",
					rating: "Encuesta",
					ratingOn: "Sí",
					ratingOff: "No",
				},
				buttons: {
					add: "Agregar nuevo",
					manageGroups: "Grupos de departamentos",
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage:
						"¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en ese departamento seguirán existiendo, pero ya no tendrán ningún departamento asignado.",
				},
			},
			closeReasonModal: {
				categories: {
					title: "Ámbitos de análisis",
					name: "Nombre del ámbito",
					none: "Sin ámbito",
				},
				title: "Motivos de cierre",
				form: {
					name: "Nombre del motivo",
				},
				buttons: {
					add: "Agregar",
					close: "Cerrar",
				},
				empty: "No hay motivos. Crea el primero arriba.",
				note: "Desactivar un motivo lo saca del modal de cierre pero lo conserva, para que los reportes históricos sigan funcionando. Bórralo solo si nunca se usó.",
				toasts: {
					created: "Motivo creado",
					updated: "Motivo actualizado",
					deleted: "Motivo eliminado",
				},
				confirmDelete: {
					title: "Eliminar motivo",
					message: "¿Seguro? Si ya se usó en cierres anteriores, es mejor desactivarlo: borrarlo hace que esos cierres pierdan la referencia.",
				},
			},
			queueGroupModal: {
				title: "Grupos de departamentos",
				form: {
					name: "Nombre del grupo",
				},
				buttons: {
					add: "Agregar",
					close: "Cerrar",
				},
				empty: "Todavía no hay grupos. Crea el primero arriba.",
				queues: "departamento(s)",
				toasts: {
					created: "Grupo creado",
					updated: "Grupo actualizado",
					deleted: "Grupo eliminado",
				},
				confirmDelete: {
					title: "Eliminar grupo",
					message: "¿Seguro? Los departamentos de este grupo NO se eliminan: quedan sin grupo y podrás reasignarlas cuando quieras.",
				},
			},
			queueSelect: {
				inputLabel: "Departamentos & ChatBot",
			},

			users: {
				title: "Usuarios",
				table: {
					name: "Nombre",
					email: "Correo Electrónico",
					profile: "Perfil",
					actions: "Acciones",
				},
				buttons: {
					add: "Agregar usuario",
				},
				toasts: {
					deleted: "Usuario borrado satisfactoriamente.",
				},
				confirmationModal: {
					deleteTitle: "Borrar",
					deleteMessage:
						"Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán al departamento.",
				},
			},
			settings: {
				success: "Configuración guardada satisfactoriamente.",
				title: "Configuración",
				settings: {
					userCreation: {
						name: "Creación de usuarios",
						options: {
							enabled: "Habilitado",
							disabled: "Deshabilitado",
						},
					},
				},
				tabs: {
					options: "Opciones",
					schedules: "Horarios",
					companies: "Empresas",
					plans: "Planes",
					helps: "Ayuda",
					contactStatus: "Estados de contacto",
					openai: "OpenAI",
					metaAds: "Anuncios (Meta)",
					metaApi: "API de Meta",
					googleAds: "Anuncios (Google)",
					asterisk: "Central telefónica",
					googleCalendar: "Google Calendar",
					attention: "Atención",
				},
				attention: {
					hours: {
						cardTitle: "Horarios de atención",
						cardSubtitle: "Fuera de este horario el cliente recibe un aviso automático.",
						mode: {
							title: "Aplicar horario",
							disabled: "Sin horario",
							company: "Toda la empresa",
							queue: "Por departamento",
							help: {
								disabled: "Se atiende a cualquier hora; no se envía aviso fuera de horario.",
								company: "Un solo horario para todos los departamentos.",
								queue: "Cada departamento tiene su propio horario y mensaje.",
							},
						},
						day: "Día",
						status: {
							title: "Atención",
							hours: "Con horario",
							closed: "Cerrado",
							allDay: "24 horas",
						},
						from: "Desde",
						to: "Hasta",
						days: {
							monday: "Lunes",
							tuesday: "Martes",
							wednesday: "Miércoles",
							thursday: "Jueves",
							friday: "Viernes",
							saturday: "Sábado",
							sunday: "Domingo",
						},
												fixErrors: "Revisa los días marcados en rojo.",
						companyMessageHint: "El mensaje fuera de horario se toma de cada conexión (WhatsApp > Mensajes).",
						queueHint: "Cada departamento configura su horario y su mensaje fuera de horario. Un departamento sin horario atiende a cualquier hora.",
						noQueues: "No hay departamentos creados.",
						queueTable: {
							queue: "Departamento",
							days: "Horario",
							message: "Mensaje fuera de horario",
							summary: "{{hours}} con horario · {{closed}} cerrado(s)",
							noSchedule: "A cualquier hora",
							missing: "Falta mensaje",
							yes: "Sí",
						},
						queueDialogTitle: "Horario de {{name}}",
						outOfHoursMessage: "Mensaje fuera de horario",
						outOfHoursHelp: "Se envía cuando el cliente escribe fuera del horario de este departamento.",
						messageRequired: "Sin este mensaje el horario no tiene efecto.",
						edit: "Editar",
						unsaved: "Cambios sin guardar",
						cancel: "Cancelar",
						save: "Guardar",
						saved: "Horario guardado.",
					},
					survey: {
						cardTitle: "Encuesta de satisfacción",
						cardSubtitle: "Encuesta que recibe el cliente cuando se resuelve el chat.",
						configure: "Configurar",
						status: {
							disabled: "Desactivada",
							company: "Activa en toda la empresa",
							queue: "Activa por departamento",
						},
						summary: {
							comment: "Pide comentario a las notas {{rates}}",
							customThanks: "{{count}} mensaje(s) personalizado(s) por calificación",
							interactive: "Lista interactiva en WhatsApp API oficial",
						},
						modalTitle: "Configurar Encuesta de Satisfacción",
						modalSubtitle: "Encuesta enviada al contacto cuando se resuelve el chat.",
						queueSubtitle: "Encuesta del departamento {{name}}.",
						queueEnabled: {
							title: "Enviar encuesta en este departamento",
							help: "Al cerrar una conversación de este departamento, el cliente recibirá la encuesta del 1 al 5.",
						},
						queueButton: "Configurar encuesta",
						queueSaveFirst: "Guarda el departamento para poder configurar su encuesta.",
						queueSends: "Envía encuesta",
						queueNotSends: "No envía encuesta",
						unsaved: "Cambios sin guardar",
						enabled: {
							title: "Activar encuesta de satisfacción",
							help: "Al cerrar una conversación, el cliente recibirá una encuesta para evaluar el servicio del 1 al 5.",
						},
						scope: {
							title: "Aplicar en",
							help: "Por departamento: cada departamento decide si la envía y tiene sus propios mensajes.",
							company: "Toda la empresa",
							queue: "Por departamento",
						},
						perDepartmentHint: "Cada departamento tiene su propia encuesta. Configúrala desde aquí o desde la ficha del departamento.",
						queueTable: {
							queue: "Departamento",
							sends: "Envía encuesta",
							settings: "Mensajes",
							yes: "Sí",
							no: "No",
							customized: "Personalizados",
							defaults: "Por defecto",
							empty: "No hay departamentos creados.",
						},
						autoClose: {
							title: "Enviar al resolver automáticamente",
							help: "Enviar encuesta también cuando el chat se resuelva automáticamente por inactividad.",
						},
						interactiveList: {
							title: "Enviar como lista interactiva",
							help: "En WhatsApp API oficial la encuesta se envía como lista para elegir la nota. En los demás canales se envía como texto.",
						},
						requestMessage: "Mensaje de solicitud",
						requestHelp: "Debajo del mensaje se agregan solas las opciones del 1 al 5.",
						thanksMessage: "Mensaje de agradecimiento (predeterminado)",
						askComment: {
							title: "Solicitar comentario",
							help: "Después de la calificación numérica, solicitar un comentario opcional del cliente.",
						},
						commentTimeout: {
							title: "Tiempo límite para comentario",
							badge: "Único",
							help: "Vale para todas las notas. Si el cliente responde después, su mensaje abre una conversación nueva.",
							unit: "min",
						},
						commentMessage: "Mensaje de solicitud de comentario",
						customThanks: {
							title: "Mensaje personalizado por calificación",
							help: "Enviar un mensaje diferente al predeterminado según la calificación del contacto.",
						},
						customMessage: "Mensaje personalizado",
						addRange: "Agregar rango",
						noComment: "No piden comentario:",
						defaultThanks: "Usan el mensaje predeterminado:",
						rangeHint: "Toca las notas para incluirlas en este rango. Las que tienen candado ya están en otro rango.",
						lockedRate: "Esta nota ya está en otro rango",
						deleteRange: "Eliminar rango",
						required: "Campo obligatorio",
						emptyRange: "Selecciona al menos una nota",
						variablesHint: "Puedes usar {{name}} para el nombre del contacto.",
						format: {
							bold: "Negrita",
							italic: "Cursiva",
							strike: "Tachado",
							emoji: "Emoji",
						},
						cancel: "Cancelar",
						save: "Guardar",
						saved: "Encuesta guardada.",
						fixErrors: "Revisa los campos marcados en rojo.",
					},
				},
				phoneSystemTabs: {
					connection: "Conexión",
					callRecords: "Registro de llamadas (CDR)",
				},
				googleAds: {
					account: {
						title: "Cuenta de Google Ads",
						subtitle: "Conectá la cuenta de Google Ads de la empresa para traer impresiones, clics y costo de cada campaña al reporte de Anuncios.",
						notConfigured: "Google Ads todavía no está configurado en el servidor (GOOGLE_ADS_CLIENT_ID y GOOGLE_ADS_CLIENT_SECRET).",
						connectHint: "Iniciá sesión con la cuenta de Google que administra tus anuncios. Solo se usa para leer los reportes.",
						connect: "Conectar con Google Ads",
						connected: "Cuenta de Google conectada",
						connectError: "No se pudo completar la conexión con Google Ads",
						missingScope: "No se marcó el permiso de Google Ads en la pantalla de Google. Desconectá, volvé a conectar y marcá la casilla “Ver, editar, crear y borrar tus cuentas y datos de Google Ads”.",
						notAdsUser: "La cuenta de Google conectada no tiene acceso a ninguna cuenta de Google Ads. Agregala como usuario en Google Ads (Administrador → Acceso y seguridad) y volvé a cargar, o desconectá y conectá con la cuenta que administra tus anuncios.",
						pickHint: "Conectado como {{email}}. Elegí la cuenta publicitaria a sincronizar.",
						adAccount: "Cuenta publicitaria",
						pickPlaceholder: "Elegí una cuenta",
						loadingAccounts: "Cargando cuentas…",
						noAccounts: "No se encontraron cuentas publicitarias activas para este usuario de Google.",
						accountsError: "Google respondió: {{error}}",
						reloadAccounts: "Volver a cargar cuentas",
						disconnectWith: "Desconectar {{email}}",
						useAccount: "Usar esta cuenta",
						cancel: "Cancelar",
						googleAccount: "Cuenta de Google",
						lastSync: "Última sincronización",
						never: "Nunca",
						autoSync: "Se sincroniza sola cada 6 horas.",
						syncNow: "Sincronizar ahora",
						synced: "{{count}} campañas sincronizadas",
						syncError: "La última sincronización falló: {{error}}",
						changeAccount: "Cambiar cuenta",
						disconnect: "Desconectar",
						disconnected: "Google Ads desconectado",
						disconnectTitle: "Desconectar Google Ads",
						disconnectConfirm: "Se dejan de sincronizar las métricas. Las campañas y los tickets ya registrados se conservan.",
					},
					forms: {
						title: "Formularios de clientes potenciales",
						subtitle: "Recibe los leads de los formularios de Google Ads: crea el contacto, abre el ticket en la conexión elegida y lo registra en el reporte de Anuncios.",
						howTo: "¿Cómo lo conecto en Google Ads?",
						step1: "Guardá esta configuración primero.",
						step2: "En Google Ads, abrí la campaña y andá a Recursos → Formularios de clientes potenciales. Creá uno o editá el existente.",
						step3: "En Opciones de exportación de clientes potenciales → Integración de webhook, pegá la URL del webhook y la Clave de abajo.",
						step4: "Pulsá Enviar datos de prueba: tiene que aparecer un ticket nuevo marcado como \"Google Ads · Campaña … (prueba)\".",
						step5: "El formulario tiene que pedir el número de teléfono: sin teléfono no se puede abrir el chat y el lead se descarta.",
						cloudNote: "Si la conexión es WhatsApp Cloud (API oficial), el primer mensaje al lead tiene que ser una plantilla aprobada.",
						sectionGoogle: "Datos para pegar en Google Ads",
						sectionDestination: "Dónde cae el lead",
						webhookUrl: "URL del webhook",
						webhookUrlHelp: "Tiene que ser la URL pública (https) del backend.",
						key: "Clave",
						keyHelp: "Va en el campo Clave del webhook en Google Ads.",
						connection: "Conexión",
						connectionHelp: "Desde este WhatsApp el agente le escribe al lead.",
						defaultConnection: "Conexión por defecto",
						queue: "Cola",
						queueHelp: "Opcional. Si no elegís, el ticket queda sin cola.",
						noQueue: "Sin cola",
						copy: "Copiar",
						copied: "Copiado",
						copyError: "No se pudo copiar",
						regenerate: "Generar clave nueva",
						regenerated: "Clave nueva generada. Guardá y actualizala también en Google Ads.",
						saved: "Configuración de Anuncios (Google) guardada",
						save: "Guardar",
					},
					links: {
						campaignLabel: "Campaña de Google Ads",
						campaignHelp: "Vincula el enlace con la campaña para cruzar su costo con los tickets que trae.",
						campaignEmpty: "Conectá la cuenta de Google Ads para elegir una campaña.",
						noCampaign: "Sin campaña",
						campaignPaused: "(pausada)",
						title: "Enlaces de WhatsApp para Google Ads",
						subtitle: "Cada enlace lleva un código en el mensaje. Cuando el cliente escribe con ese código, el ticket queda marcado con la campaña y aparece en el reporte de Anuncios. Pegá el enlace como URL final del anuncio.",
						newLink: "Nuevo enlace",
						name: "Nombre",
						code: "Código",
						phone: "Número",
						message: "Mensaje",
						queue: "Cola",
						actions: "Acciones",
						empty: "Todavía no hay enlaces. Creá uno por cada campaña que quieras distinguir.",
						copyLink: "Copiar enlace",
						linkCopied: "Enlace copiado",
						copyError: "No se pudo copiar",
						edit: "Editar",
						delete: "Eliminar",
						newTitle: "Nuevo enlace",
						editTitle: "Editar enlace",
						nameLabel: "Nombre de la campaña",
						namePlaceholder: "Campaña Verano",
						nameHelp: "Así se va a ver en el ticket y en el reporte de Anuncios.",
						phoneLabel: "Número de WhatsApp",
						phoneHelp: "Con código de país, sin + ni espacios.",
						messageLabel: "Mensaje precargado",
						messageHelp: "El código se agrega solo al final del mensaje.",
						queueHelp: "Opcional. Si el ticket no tiene agente, pasa a esta cola.",
						noQueue: "Sin cola",
						previewLabel: "Así lo va a enviar el cliente",
						previewHint: "El código se genera al guardar.",
						defaultMessage: "Hola, quiero información",
						cancel: "Cancelar",
						save: "Guardar",
						created: "Enlace creado",
						updated: "Enlace actualizado",
						deleted: "Enlace eliminado",
						deleteTitle: "Eliminar enlace",
						deleteConfirm: "Se elimina \"{{name}}\" ({{code}}). Los tickets que ya llegaron por este enlace conservan su registro, pero los mensajes nuevos con ese código dejarán de marcarse.",
					},
				},
				optionsTab: {
					brandColor: "Color de marca",
					brandColorHelp: "Cabecera del reporte",
					logo: "Logo",
					logoHelp: "PNG o JPG. Se muestra en el panel y en los reportes.",
					logoDrop: "Arrastra o haz clic para cambiar el logo",
					slaTitle: "Objetivos de tiempo (minutos)",
					slaFirstReply: "Primera respuesta",
					slaWait: "Espera hasta que lo tomen",
					slaHandle: "Atención hasta cerrarlo",
					slaHelp: "El tablero marca en verde o rojo según se cumplan.",
					updating: "Actualizando...",
					sections: {
						appearance: {
							title: "Apariencia",
							subtitle: "El logo y el color con el que se identifica tu empresa en reportes y en el panel.",
						},
						botBehavior: {
							title: "Comportamiento del bot",
							subtitle: "Cómo responde el chatbot y qué mensajes atiende.",
						},
						serviceAndSla: {
							title: "Atención y tiempos (SLA)",
							subtitle: "Reglas de evaluación, llamadas y los tiempos que marca el tablero en verde o rojo.",
						},
						tickets: {
							title: "Tickets",
							subtitle: "Registro de actividad y motivos de cierre disponibles para los agentes.",
						},
					},
					ratings: {
						label: "Evaluaciones",
						disabled: "Deshabilitadas",
						queue: "Gestión por Departamentos",
						company: "Gestión por Empresa",
						help: "Por Departamentos: cada departamento decide en su propia configuración. Por Empresa: se pide siempre, igual para todas.",
					},
					scheduleType: {
						label: "Gestión de Horarios",
						disabled: "Deshabilitado",
						queue: "Gestión por Departamentos",
						company: "Gestión por Empresa",
						help: "Quién define los horarios de atención: nadie (deshabilitado), cada departamento por separado, o uno solo para toda la empresa.",
					},
					ignoreGroupMsgs: {
						label: "Ignorar Mensajes de Grupos",
						disabled: "Desactivado",
						enabled: "Activado",
						help: "Si está activado, los mensajes que lleguen desde un grupo de WhatsApp no generan tickets.",
					},
					activityLog: {
						manageReasons: "Motivos de cierre",
						manageReasonsHelp: "Los motivos que el agente elige al cerrar un ticket.",
						manage: "Administrar",
						label: "Registro de Actividades",
						disabled: "Desactivado",
						enabled: "Activado",
						help: "Si está activado, queda un historial de las acciones de los agentes sobre los tickets.",
					},
					callType: {
						label: "Aceptar llamada",
						disabled: "No Aceptar",
						enabled: "Aceptar",
						help: "Si está en \"No Aceptar\", el sistema rechaza las llamadas entrantes automáticamente.",
					},
					chatbotType: {
						label: "Tipo Chatbot",
						text: "Texto",
						button: "Botón",
						list: "Lista",
						help: "Cómo se le muestran al cliente las opciones del menú del bot.",
					},
					ticketFieldsTab: "Configuración de Opciones de Tipo de Ticket",
					infoType: "Tipo de Información",
					valueLabel: "Valor",
					newButton: "Nuevo",
					saveChanges: "Guardar Cambios",
				},
			},
			messagesList: {
				header: {
					assignedTo: "Asignado a:",
					buttons: {
						return: "Devolver",
						resolve: "Resolver",
						reopen: "Reabrir",
						accept: "Aceptar",
					},
				},
			},
			messagesInput: {
				placeholderOpen: "Escribe un mensaje",
				placeholderClosed:
					"Vuelva a abrir o acepte este ticket para enviar un mensaje.",
				signMessage: "Firmar",
			},
			contactDrawer: {
				header: "Detalles del contacto",
				buttons: {
					edit: "Editar contacto",
					sendToCRM: "Enviar a CRM",
				},
				extraInfo: "Otra información",
				connectedInfo: "Conexion disponible",
				viewExternalProfile: "Ver Perfil"
			},
			ticketOptionsMenu: {
				delete: "Borrar",
				transfer: "Transferir",
				block: "Bloquear",
				schedule: "Agendamiento",
				registerAppointment: "Notas de contacto",
				appointmentsModal: {
					title: "Observación del Contacto",
					textarea: "Observación",
					placeholder: "Ingresa los datos que deseas registrar aquí",
				},
				confirmationModal: {
					title: "¿Borrar ticket #",
					titleFrom: "del contacto ",
					message:
						"¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
				},
				confirmationModalBlock: {
					title: "¿Quieres bloquear el ticket #",
					titleFrom: "del contacto ",
					message:
						"¡Atención! Por el momento no se podra desbloquear el contacto.",
				},
				buttons: {
					delete: "Borrar",
					cancel: "Cancelar",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancelar",
				},
			},
			messageOptionsMenu: {
				delete: "Borrar",
				reply: "Responder",
				confirmationModal: {
					title: "¿Borrar mensaje?",
					message: "Esta acción no puede ser revertida.",
				},
			},
			facebookComment: {
				pending: "Viene de un comentario en una publicación. Puedes enviarle 1 solo mensaje privado, solo texto, hasta el {{deadline}}. Si responde, sigue como chat normal.",
				waiting: "Ya enviaste el mensaje privado. Podrás volver a escribirle cuando la persona responda.",
				expired: "Pasaron más de 7 días desde el comentario. Ya no se le puede escribir por privado.",
				viewPost: "Ver publicación",
			},
			metaGraphVersion: {
				title: "Versión de la API de Meta",
				subtitle: "Versión de Graph API y apps de Meta que usa toda la plataforma (Messenger, Instagram, WhatsApp Cloud, plantillas y anuncios). Aplica a todas las empresas al guardar, sin reiniciar.",
				version: "Versión",
				released: "Publicada",
				expires: "Vence",
				noExpiry: "Sin fecha",
				inUse: "en uso",
				save: "Guardar",
				saved: "Versión de Meta actualizada",
				versionSection: "Versión de la API",
				mainApp: "App de Facebook e Instagram",
				whatsappApp: "App de WhatsApp Cloud (conexión, coexistencia y plantillas)",
				appId: "ID de la app",
				appSecret: "Secreto de la app",
				configId: "ID de configuración",
				secretSaved: "Guardado · escribe para cambiarlo",
				missingApp: "Falta configurar la app de Meta",
			},
			backendErrors: {
				ERR_META_GRAPH_VERSION_INVALID: "La versión debe tener el formato v26.0.",
				ERR_FACEBOOK_COMMENT_WAITING_CUSTOMER: "Ya enviaste el mensaje privado a este comentario. Podrás escribirle de nuevo cuando la persona responda.",
				ERR_FACEBOOK_COMMENT_REPLY_EXPIRED: "Pasaron más de 7 días desde el comentario. Facebook ya no permite responderle por privado.",
				ERR_FACEBOOK_COMMENT_TEXT_ONLY: "La respuesta privada a un comentario solo puede ser texto.",
				ERR_FACEBOOK_COMMENT_REPLY_FAILED: "No se pudo enviar la respuesta privada al comentario.",
				ERR_KNOWLEDGE_STORE_NOT_CONFIGURED: "La base de conocimiento no está configurada en el servidor (faltan las variables KNOWLEDGE_SUPABASE_*).",
				ERR_KNOWLEDGE_USAGE_REQUIRED: "Escriba cuándo debe consultar este documento el agente.",
				ERR_KNOWLEDGE_NO_ITEMS_LEFT: "El registro debe tener al menos una regla. Si no sirve, recházelo.",
				ERR_KNOWLEDGE_SUPABASE_FORBIDDEN: "Supabase no dio permiso para escribir. La conexión necesita la llave service_role.",
				ERR_KNOWLEDGE_SUPABASE_NO_TABLE: "Falta crear la tabla knowledge_vectors en Supabase (corra el SQL de instalación).",
				ERR_KNOWLEDGE_SUPABASE_ERROR: "Supabase respondió con un error al publicar. Intente de nuevo.",
				ERR_KNOWLEDGE_EMBEDDING_FAILED: "No se pudieron generar los vectores con OpenAI. Intente de nuevo.",
				ERR_KNOWLEDGE_NOTHING_APPROVED: "No hay reglas aprobadas para publicar.",
				ERR_KNOWLEDGE_NOT_READY: "El documento todavía no está listo para publicar.",
				ERR_KNOWLEDGE_UNPUBLISH_FIRST: "Despublique el documento antes de volver a procesarlo.",
				ERR_KNOWLEDGE_EMPTY_PATH: "Escriba la ubicación en el documento.",
				ERR_KNOWLEDGE_ONLY_PDF: "Solo se aceptan archivos PDF.",
				ERR_KNOWLEDGE_NAME_REQUIRED: "Escriba un nombre para el documento.",
				ERR_KNOWLEDGE_EMPTY_TEXT: "Escriba el texto antes de guardar.",
				ERR_KNOWLEDGE_TEXT_TOO_LONG: "El texto es demasiado largo. Divídalo en varios documentos.",
				ERR_KNOWLEDGE_DUPLICATE_TEXT: "Ese mismo texto ya está guardado.",
				ERR_KNOWLEDGE_ASSISTANT_GOAL_REQUIRED: "Escriba qué quiere que sepa el agente.",
				ERR_PROMPT_BUILDER_GOAL_REQUIRED: "Escriba qué tiene que hacer el agente.",
				ERR_TRANSCRIPTION_NO_AUDIO: "No llegó audio para transcribir. Intente de nuevo.",
				ERR_PROMPT_BUILDER_TOO_LONG: "El prompt es demasiado largo para revisarlo de una vez.",
				ERR_NO_PROMPT_FOUND: "No se encontró el prompt.",
				ERR_KNOWLEDGE_SOURCE_TYPE: "Solo se pueden adjuntar archivos PDF o TXT.",
				ERR_KNOWLEDGE_SOURCE_NO_TEXT: "No se pudo leer texto del archivo. Si es un PDF escaneado, súbalo con \"Subir PDF\".",
				ERR_KNOWLEDGE_SOURCE_NOT_FOUND: "El manual adjunto ya no está disponible. Vuelva a adjuntarlo.",
				ERR_KNOWLEDGE_NO_API_KEY: "Ese agente no tiene clave de OpenAI configurada.",
				ERR_KNOWLEDGE_DUPLICATE_FILE: "Ese mismo archivo ya fue subido para este agente.",
				ERR_KNOWLEDGE_NOT_FOUND: "No se encontró el documento.",
				ERR_KNOWLEDGE_ENTRY_NOT_FOUND: "No se encontró el registro.",
				ERR_KNOWLEDGE_BUSY: "El documento se está procesando. Espere a que termine.",
				ERR_KNOWLEDGE_INTERRUPTED: "El procesamiento se interrumpió (por ejemplo, por un reinicio del servidor). Vuelva a procesarlo.",
				ERR_KNOWLEDGE_INVALID_COUNTRY: "El país no es válido.",
				ERR_KNOWLEDGE_ITEMS_MISMATCH: "Las reglas no coinciden con el registro. Recargue la página.",
				ERR_KNOWLEDGE_EMPTY_ITEM: "Ninguna regla puede quedar vacía.",
				ERR_KNOWLEDGE_INVALID_STATUS: "Estado no válido.",
				ERR_PROMPT_COACH_NO_VALID_EDIT: "No pude convertir la corrección en un cambio válido del prompt. Intente decirlo de otra forma, más concreta.",
				ERR_PROMPT_COACH_EMPTY_CORRECTION: "Escriba qué estuvo mal o qué debió hacer el agente.",
				ERR_PROMPT_TEST_EMPTY_MESSAGE: "Escriba un mensaje.",
				ERR_PROMPT_VOICE_TEST_SPECIALIST: "Los especialistas se prueban solo por texto.",
				ERR_PROMPT_VOICE_TEST_OPENAI: "OpenAI no pudo iniciar la llamada de prueba. Revise la clave de API y el modelo de voz del agente.",
				ERR_PROMPT_MUST_BE_VOICE: "Esta conexión es de llamada: solo admite prompts de tipo Llamada.",
				ERR_PROMPT_MUST_BE_TEXT: "Solo se pueden asignar prompts de tipo Texto aquí.",
				ERR_CLOSE_REASON_REQUIRED_FOR_AD: "Este chat llegó por un anuncio: elegí un motivo de cierre antes de finalizarlo.",
				ERR_NO_OTHER_WHATSAPP:
					"Debe haber al menos una conexión de WhatsApp predeterminada.",
				ERR_NO_DEF_WAPP_FOUND:
					"No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
				ERR_WAPP_NOT_INITIALIZED:
					"Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
				ERR_WAPP_CHECK_CONTACT:
					"No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
				ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
				ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
				ERR_SENDING_WAPP_MSG:
					"Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
				ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
				ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
				ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
				ERR_USER_CREATION_DISABLED:
					"La creación de usuarios fue deshabilitada por el administrador.",
				ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
				ERR_NO_QUEUE_FOUND: "No se encontró el departamento.",
				ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
				ERR_NO_SETTING_FOUND:
					"No se encontró ninguna configuración con este ID.",
				ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
				ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
				ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
				ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
				ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
				ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
				ERR_FETCH_WAPP_MSG:
					"Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"Este color ya está en uso, elija otro.",
				ERR_WAPP_GREETING_REQUIRED:
					"El mensaje de saludo es obligatorio cuando hay más de un departamento.",
			},
		},
	},
};

export { messages };
